// import { enableEslintTypescript } from 'customize-cra';
import moment from 'moment';
import { Api } from '../services';
import { UPDATE_PROFILE } from './profile';
import Notification from "services/Notification";
import { fetchMarkingSchemeDataTS } from './marketTest';


export const POST_TEST_CREATE = 'POST_TEST_CREATE';
export const UPDATE_PIECHART_DATA = 'UPDATE_PIECHART_DATA'
export const UPDATE_CLASSCARD_DATA = 'UPDATE_CLASSCARD_DATA'
export const SET_SELECTED_CLASSROOM = 'SET_SELECTED_CLASSROOM'
export const UPDATE_RESULT_TO_PUBLISH = 'UPDATE_RESULT_TO_PUBLISH'
export const UPDATE_SUBMITTED_TESTS = 'UPDATE_SUBMITTED_TESTS'
export const UPDATE_SUBMITTED_TESTS_DETAILS = 'UPDATE_SUBMITTED_TESTS_DETAILS'
export const UPDATE_EVALUATED_MARK = 'UPDATE_EVALUATED_MARK'
export const UPDATE_EVALUATED_COMMENT = 'UPDATE_EVALUATED_COMMENT'
export const UPDATE_SUBMITTED_TESTS_BY_STUDENT_ID = 'UPDATE_SUBMITTED_TESTS_BY_STUDENT_ID'
export const UPDATE_EVALUATION_QUESTION_DATA = 'UPDATE_EVALUATION_QUESTION_DATA'
export const UPDATE_QUESTION_GRIDS_ARRAY = 'UPDATE_QUESTION_GRIDS_ARRAY'
export const UPDATE_EVALUATION_QUESTION_ID = 'UPDATE_EVALUATION_QUESTION_ID'
export const UPDATE_CURRENT_QUESTION_INDEX = 'UPDATE_CURRENT_QUESTION_INDEX'
export const UPDATE_SUBMITTED_TESTS_ID = 'UPDATE_SUBMITTED_TESTS_ID'
export const UPDATE_SUBMITTED_TESTS_SUBMITTED_ID = 'UPDATE_SUBMITTED_TESTS_SUBMITTED_ID'
export const UPDATE_POST_EVALUATION_OBJECT = 'UPDATE_POST_EVALUATION_OBJECT'
export const UPDATE_SUBMITTED_TESTS_USERS = 'UPDATE_SUBMITTED_TESTS_USERS'
export const UPDATE_PUBLISHED_RESULT = 'UPDATE_PUBLISHED_RESULT'
export const SET_TEXT_FALSE = "SET_TEXT_FALSE"
export const UPDATE_TEST_TO_PUBLISH = 'UPDATE_TEST_TO_PUBLISH'
export const UPDATE_ONGOING_TEST = 'UPDATE_ONGOING_TEST'
export const UPDATE_DRAFTS = 'UPDATE_DRAFTS'
export const UPDATE_BARCHART_DATA = 'UPDATE_BARCHART_DATA'
export const SET_SELECTED_CLASSROOM_ID = 'SET_SELECTED_CLASSROOM_ID'
export const UPDATE_SUBJECTS_BY_CLASS = 'UPDATE_SUBJECTS_BY_CLASS'
export const SET_SELECTED_SUBJECT = 'SET_SELECTED_SUBJECT'
export const UPDATE_STANDARDWISE_BARCHART_DATA = 'UPDATE_STANDARDWISE_BARCHART_DATA'
export const UPDATE_TODAY_ACTIVITY = 'UPDATE_TODAY_ACTIVITY'
export const UPDATE_UPCOMING_TESTS = 'UPDATE_UPCOMING_TESTS'
export const UPDATE_NO_DATA = 'UPDATE_NO_DATA'
export const UPDATE_STANDARDS_LIST = 'UPDATE_STANDARDS_LIST'
export const GET_TEST_NAME_ARR = 'GET_TEST_NAME_ARR'
export const UPDATE_STUDENT_RESULT = 'UPDATE_STUDENT_RESULT'
export const UPDATE_SELECTED_TEST = 'UPDATE_SELECTED_TEST'
export const UPDATE_SELECTED_STUDENT = 'UPDATE_SELECTED_STUDENT'
export const GET_RESULTS_LOADER = 'GET_RESULTS_LOADER'
export const UPDATE_CANCELLED_TESTS = 'UPDATE_CANCELLED_TESTS'
export const UPDATE_SELECTED_TEST_ID = 'UPDATE_SELECTED_TEST_ID'
export const SET_EDIT_MODAL_VISIBLE = 'SET_EDIT_MODAL_VISIBLE'
export const SET_C_MODAL_VISIBLE = 'SET_C_MODAL_VISIBLE'
export const SET_C_MODAL_TYPE = 'SET_C_MODAL_TYPE'
export const TOGGLE_RELOADER_FLAG = 'TOGGLE_RELOADER_FLAG'
export const GET_INDEX_OF_TEST = 'GET_INDEX_OF_TEST'
export const CLEAR_TEST_CREATE_OBJ = 'CLEAR_TEST_CREATE_OBJ'
export const PREFILL_TEST_CREATE_OBJ = 'PREFILL_TEST_CREATE_OBJ'
export const SET_AI_HANDOFF = 'SET_AI_HANDOFF'
export const CLEAR_AI_HANDOFF = 'CLEAR_AI_HANDOFF'
export const STORE_GENERATE_QUESTIONS_OBJ = 'STORE_GENERATE_QUESTIONS_OBJ'
export const SHOW_TEXT_EDITOR = 'SHOW_TEXT_EDITOR'
export const UPDATE_SUB_WITH_CHAPTERS = 'UPDATE_SUB_WITH_CHAPTERS'
export const ADD_MARKS_FOR_QUES = 'ADD_MARKS_FOR_QUES'
export const RENDER_EDITOR_CONTENT = 'RENDER_EDITOR_CONTENT'
export const CHOOSE_CORRECT_ANSWER_ADMIN = 'CHOOSE_CORRECT_ANSWER_ADMIN'
export const STORE_TEST_QUES_TYPE = 'STORE_TEST_QUES_TYPE'
export const POST_QUESTION_CREATE = 'POST_QUESTION_CREATE'
export const UPDATE_LIST_OF_QUESTIONS = 'UPDATE_LIST_OF_QUESTIONS'
export const STORE_EDITOR_REMOVED_IMGS = 'STORE_EDITOR_REMOVED_IMGS'
export const STORE_EDITOR_ADDED_IMGS = 'STORE_EDITOR_ADDED_IMGS'
export const DELETE_QUILL_IMGS = 'DELETE_QUILL_IMGS'
export const CLEAR_GENERATE_QUES_FIELDS = 'CLEAR_GENERATE_QUES_FIELDS'
export const RESET_GENERATE_QUES_FIELDS = 'RESET_GENERATE_QUES_FIELDS'
export const STORE_EDIT_GENERATE_QUE_ID = 'STORE_EDIT_GENERATE_QUE_ID'
export const GET_EACT_QUES_DATA_LOADER = 'GET_EACT_QUES_DATA_LOADER'
export const GENERATE_QUES_LIST_VIEW_LOADER = 'GENERATE_QUES_LIST_VIEW_LOADER'
export const STORE_GENERATE_QUES_LIST_VIEW = 'STORE_GENERATE_QUES_LIST_VIEW'
export const CHANGE_TEST_STATUS_LOADER = 'CHANGE_TEST_STATUS_LOADER'
export const CHANGE_TEST_STATUS_MODAL = 'CHANGE_TEST_STATUS_MODAL'
export const CREATE_TEST_MODAL = 'CREATE_TEST_MODAL'
export const UNSET_CREATE_TEST_MODAL_BOOL = 'UNSET_CREATE_TEST_MODAL_BOOL'
export const UPDATE_LISTVIEW_TYPE = 'UPDATE_LISTVIEW_TYPE'
export const UPDATE_FEEDBACK_DATA = 'UPDATE_FEEDBACK_DATA'
export const UPDATE_READY_TO_PUBLISH = 'UPDATE_READY_TO_PUBLISH'
export const UPDATE_ROLE = 'UPDATE_ROLE'
export const UPDATE_FEEDBACK_FROM_TEACHER = 'UPDATE_FEEDBACK_FROM_TEACHER'
export const UPDATE_DATA_OPERATOR_STATS = 'UPDATE_DATA_OPERATOR_STATS'
export const TESTING = 'TESTING'
export const UPDATE_TESTS_TO_REVIEW = 'UPDATE_TESTS_TO_REVIEW'
export const EDIT_DETAILS_LOADER = 'EDIT_DETAILS_LOADER'
export const CLONE_LOADER = 'CLONE_LOADER'
export const UPDATE_RESULTS_DATA = 'UPDATE_RESULTS_DATA'
export const UPDATE_SELECTED_CARD_TYPE = 'UPDATE_SELECTED_CARD_TYPE'
export const UPDATE_SUBMITTEDTEST_ABSENTSTUDENTS = 'UPDATE_SUBMITTEDTEST_ABSENTSTUDENTS'
export const UPDATE_TOTAL_MARKS_OBTAINED = 'UPDATE_TOTAL_MARKS_OBTAINED'
export const UPDATE_PALETTE_DATA = 'UPDATE_PALETTE_DATA'
export const UPDATE_NUMERIC_ANSWER = 'UPDATE_NUMERIC_ANSWER'
export const UPDATE_POST_PARAMS2 = 'UPDATE_POST_PARAMS2'
export const SET_OPEN_TAB = 'SET_OPEN_TAB'
export const UPDATE_STD_FOR_CREATING_TEST = 'UPDATE_STD_FOR_CREATING_TEST'
export const SET_DASHBOARD_META = 'SET_DASHBOARD_META'
export const UPDATE_CHAPTER_FOR_CREATING_TEST = 'UPDATE_CHAPTER_FOR_CREATING_TEST'
export const REMOVE_SELECTED_CHAPTER = 'REMOVE_SELECTED_CHAPTER'
export const UPDATE_SYLLABUS = 'UPDATE_SYLLABUS'
export const UPDATE_FILTER = 'UPDATE_FILTER'
export const SET_CHAPTERS_LIST = 'SET_CHAPTERS_LIST'
export const SET_LOADER = 'SET_LOADER'
export const UPDATE_GROUPED_CHAPTER_FOR_CREATING_TEST = 'UPDATE_GROUPED_CHAPTER_FOR_CREATING_TEST'
export const UPDATE_TODAY_RESULTS = 'UPDATE_TODAY_RESULTS'
export const SET_SELECTED_SECTION_ID = 'SET_SELECTED_SECTION_ID'
export const CHOOSE_BOOL_ANSWER = 'CHOOSE_BOOL_ANSWER'
export const ADD_NEW_QUESTIONS = 'ADD_NEW_QUESTIONS'
export const SET_SUBJECT_SECTION = 'SET_SUBJECT_SECTION'
export const STORE_MARKING_SCHEME_DATA = 'STORE_MARKING_SCHEME_DATA'
export const UPDATE_QUESTION_TYPE = 'UPDATE_QUESTION_TYPE'
export const UPDATE_CODING_QUESTION = 'UPDATE_CODING_QUESTION'
export const STORE_QUESTION_INDEX = 'STORE_QUESTION_INDEX'
export const STORE_SECTION_INDEX = 'STORE_SECTION_INDEX'
export const STORE_MARKING_SCHEME_CARD_DATA = "STORE_MARKING_SCHEME_CARD_DATA";
export const SEARCH_FILTER = "SEARCH_FILTER";
export const STORE_MARKING_SCHEME_TITLE = "STORE_MARKING_SCHEME_TITLE";
export const STORE_MARKING_SCHEME_DESC = "STORE_MARKING_SCHEME_DESC";
export const STORE_MARKING_SCHEME_SUBJECTIVE = "STORE_MARKING_SCHEME_SUBJECTIVE";
export const STORE_MARKING_SCHEME_OBJECTIVE = "STORE_MARKING_SCHEME_OBJECTIVE";
export const STORE_MARKED_SCHEME_CARD_ID = "STORE_MARKED_SCHEME_CARD_ID";
export const MARKED_SCHEME_CARD_DETAILS = "MARKED_SCHEME_CARD_DETAILS";
export const CREATE_ADDITIONAL_QUESTION = 'CREATE_ADDITIONAL_QUESTION';
export const STORE_SCHEME_ID = 'STORE_SCHEME_ID'
export const FROM_CREATE_NEW_BUTTON = "FROM_CREATE_NEW_BUTTON";
export const SET_FROM_SECTION_MARKING_SCHEME = "SET_FROM_SECTION_MARKING_SCHEME"
export const ADD_MARKING_SCHEME_MARKS = 'ADD_MARKING_SCHEME_MARKS';
export const TOTAL_QUES_IN_CHAPTER = "TOTAL_QUES_IN_CHAPTER";
export const STORE_DELETING_CHAPTER_ID = "STORE_DELETING_CHAPTER_ID";
export const STORE_IMPORT_TEST_ID = "STORE_IMPORT_TEST_ID";
export const STORE_SUBJECT_NAME = "STORE_SUBJECT_NAME";
export const STORE_LIST_VIEW_DATA = "STORE_LIST_VIEW_DATA";
export const STORE_PAGE_NUMBER = "STORE_PAGE_NUMBER";
export const STORE_SUBJECT_ID = "STORE_SUBJECT_ID";
export const STORE_QUESTION_PALETTE_DATA = "STORE_QUESTION_PALETTE_DATA";
export const MODIFY_OPTIONS = 'MODIFY_OPTIONS'
export const STORE_CHAPTERS = 'STORE_CHAPTERS'
export const SET_FROM_IMPORT_LIST_VIEW = 'SET_FROM_IMPORT_LIST_VIEW'
export const SAVE_START_TIME = 'SAVE_START_TIME'

const updateTestToPublish = data => (
  {
    type: UPDATE_TEST_TO_PUBLISH,
    data
  }
)

const updateResultToPublish = data => (
  {
    type: UPDATE_RESULT_TO_PUBLISH,
    data
  }
)
const updateSubmittedTests = data => (
  {
    type: UPDATE_SUBMITTED_TESTS,
    data
  }
)
const updatePublishedResult = data => (
  {
    type: UPDATE_PUBLISHED_RESULT,
    data
  }
)
export const updateSubmittedTestsDetails = value => (
  {
    type: UPDATE_SUBMITTED_TESTS_DETAILS,
    value
  }
)
const updateSubmittedTestsByStudentId = value => (
  {
    type: UPDATE_SUBMITTED_TESTS_BY_STUDENT_ID,
    value
  }
)
export const updateEvaluationQuestionData = value => (
  {
    type: UPDATE_EVALUATION_QUESTION_DATA,
    value
  }
)
const updateQuestionGridsArray = value => (
  {
    type: UPDATE_QUESTION_GRIDS_ARRAY,
    value
  }
)
export const updateEvaluationQuestionId = value => (
  {
    type: UPDATE_EVALUATION_QUESTION_ID,
    value
  }
)
const updateSubmittedTestsUsers = data => (
  {
    type: UPDATE_SUBMITTED_TESTS_USERS,
    data
  }
)
//Mark given by Admin/Teacher
export const updateEvaluatedMark = value => (
  {
    type: UPDATE_EVALUATED_MARK,
    value
  }
)
//comment given by Admin/Teacher
export const updateEvaluatedComment = value => (
  {
    type: UPDATE_EVALUATED_COMMENT,
    value
  }
)

export const STORE_CREATE_TEST_MODAL_DATA = 'STORE_CREATE_TEST_MODAL_DATA';
export const GET_EXAMINER_NAME = 'GET_EXAMINER_NAME';
export const GET_EXAMINER_LOADER = 'GET_EXAMINER_LOADER';
export const GET_SUBJECTS_LOADER = 'GET_SUBJECTS_LOADER';
export const GET_EVALUATION_PAGE_LOADER = 'GET_EVALUATION_PAGE_LOADER';
export const GET_SUBJECTS_NAME = 'GET_SUBJECTS_NAME';
export const REMOVE_SELECTED_SEARCHED_SUBJS = 'REMOVE_SELECTED_SEARCHED_SUBJS';
export const UPDATE_ONE_STUDENT_RESULT = 'UPDATE_ONE_STUDENT_RESULT'
export const SET_IMPORT_META = 'SET_IMPORT_META'

export const storeCreateTestModalData = (key, value) => ({
  type: STORE_CREATE_TEST_MODAL_DATA,
  key,
  value,
});

export const universalLoader = (name, varname, bool) => ({
  type: name,
  varname,
  bool,
});

export const updateCurrentQuestionIndex = value => ({
  type: UPDATE_CURRENT_QUESTION_INDEX,
  value
})

export const updateSubmittedTestsId = value => ({
  type: UPDATE_SUBMITTED_TESTS_ID,
  value
})

export const updateSubmittedTestsStudentId = value => ({
  type: UPDATE_SUBMITTED_TESTS_SUBMITTED_ID,
  value
})

export const updatePostEvaluationObject = () => ({
  type: UPDATE_POST_EVALUATION_OBJECT,
})

export const setSelectedClassroom = newSelection => ({
  type: SET_SELECTED_CLASSROOM,
  newSelection
})

export const setSelectedClassroomId = data => ({
  type: SET_SELECTED_CLASSROOM_ID,
  data
})
const updatePiechartData = pieData => ({
  type: UPDATE_PIECHART_DATA,
  pieData
})

const updateClassCardData = classTestInfo => ({
  type: UPDATE_CLASSCARD_DATA,
  classTestInfo
})


const handleClassCardData = (dispatch, subjects) => {
  const subjectLength = subjects?.length ?? 0;
  const classdata = {}
  let currentStandard = "";
  let newData = {}
  for (let i = 0; i < subjectLength; i++) {
    currentStandard = subjects[i].standard_std;
    newData = {
      id: subjects[i].standard_id,
      section: subjects[i].standard_section,
      stream: subjects[i].standard_stream,
      chapterTestCount: subjects[i].chapterTestCount,
      partTestCount: subjects[i].partTestCount,
      fullTestCount: subjects[i].fullTestCount
    }
    if (currentStandard in classdata) {
      classdata[currentStandard].push(newData)
    }
    else {
      classdata[currentStandard] = [newData];
    }
  }
  dispatch(updateClassCardData(classdata))
}

const updateStandards = (data) => ({
  type: UPDATE_STANDARDS_LIST,
  data
})

export const testing = (data) => ({
  type: TESTING,
  data
});

export const setChaptersList = (res) => ({
  type: SET_CHAPTERS_LIST,
  res
})


export const fetchDashBoardData = (callback, filter = "", startDate = "", endDate = "") => {
  return (dispatch, getState) => {
    const { userType } = getState().testAdmin;
    dispatch(setLoader('indexLoader', true));
    return Api.get(`/testv2`).send((response) => {
      if (response !== undefined) {
        handleClassCardData(dispatch, response.standards);
        if (response.standards) {
          const stds = response.standards?.map((item) => ({ id: item.standard_id, std: item.standard_std, section: item.standard_section }))
          dispatch(updateStdForCreatingTest(stds));
        }
        dispatch(updateStandards(response.standards));
        const { userType } = getState().testAdmin;
        if (userType == "admin") {
          dispatch(setDashboardMeta({
            feedbackCount: response.feedbackCount,
            ongoingCount: response.ongoingCount,
            readyToPublishCount: response.readyToPublishCount,
            resultCount: response.resultCount,
            resultsPublishedCount: response.resultsPublishedCount,
            reviewCount: response.reviewCount
          }));
          dispatch(updateTestsToReview(response.review));
          dispatch(updatePiechartData(response.pieChart));
          dispatch(updateResultToPublish(response.results));
          dispatch(updateSubmittedTests(response.submittedTests));
          dispatch(updateOngoingTest(response.ongoing));
          dispatch(updateFeedbackFromTeacher(response.feedback));
          dispatch(updateTestToPublish(response.readyToPublish));
          dispatch(updatePublishedResult(response.resultsPublished));
          // dispatch(updateResultsData(response))
        }
        else if (userType == "dataOperator") {
          dispatch(setDashboardMeta({
            feedbackCount: response.feedbackCount,
          }));
          dispatch(updateFeedbackFromTeacher(response.feedback));
          dispatch(updateOperatorStats(response.overAllStats));

        }
        else if (userType == "teacher") {
          // dispatch(updateFeedbackFromTeacher(response.feedback));
          dispatch(setDashboardMeta({
            reviewCount: response.reviewCount,
            ongoingCount: response.ongoingCount
          }));
          dispatch(updateOngoingTest(response.ongoing));
          dispatch(updateTestsToReview(response.review));
          // dispatch(updateResultToPublish(response.results));
          dispatch(updatePiechartData(response.pieChart));
        }
        dispatch(setLoader('indexLoader', false));
      }
      callback(false);
    })
  }
}


export const fetchStandards = (callback = null) => {
  return (dispatch, getState) => {
    const { filter } = getState().testAdmin;
    const params = {
      search: filter.indexSearch
    }
    dispatch(setLoader('indexSearchLoader', true));
    return Api.get(`/testv2/standards`).params(params).send((response) => {
      if (response !== undefined) {
        handleClassCardData(dispatch, response);
      }
      dispatch(setLoader('indexSearchLoader', false));
      // callback(false);
    })
  }
}


export const fetchTests = (type, callback, startDate = "", endDate = "", searchText = "", standardId = '', subjectId = '') => {
  return (dispatch, getState) => {
    // console.log("from fetch test to publish", startDate, endDate, searchText);
    dispatch(universalLoader('GET_RESULTS_LOADER', 'getResultsBool', true));
    const { selectedClassroom } = getState().testAdmin;
    let declared = '';
    if (type == "test-result-published") {
      declared = true;
    }
    return Api.get(`/testv2/${type}?startDate=${startDate}&endDate=${endDate}&name=${searchText}&declared=${declared}&standardId=${standardId}&subjectId=${subjectId}`).send((response) => {
      if (response !== undefined) {
        if (type == "test-publish") {
          dispatch(updateTestToPublish(response.testToPublish));
        }
        else if (type == "test-result-published") {
          dispatch(updatePublishedResult(response.tests))
        }
        else if (type == "test-result-publish") {
          dispatch(updateResultsData(response))
        }
        dispatch(universalLoader('GET_RESULTS_LOADER', 'getResultsBool', false));
        callback(false);
      }
    })
  }
}


export const fetchTestsByStage = (type, callback) => {
  return (dispatch, getState) => {
    // console.log("from fetch test to publish", startDate, endDate, searchText);
    dispatch(universalLoader('GET_RESULTS_LOADER', 'getResultsBool', true));
    const { selectedClassroom, filter, selectedSubject } = getState().testAdmin;
    const params = {

    }
    if (filter.isTabPage) {
      dispatch(setLoader('tabPageLoader', true));
    } else if (filter.isVA) {
      dispatch(setLoader('vaPageLoader', true));
    }
    if (filter.isVA) {
      params.name = filter.VAsearch,
        params.syllabus = filter.VAsyllabus,
        params.standardIds = filter.VAclasses,
        params.page = -1
      params.testDate = filter.VAtype === 'results' ? null : filter.isVAdatefiltered ? filter.vaDate : null
      params.resultDate = filter.VAtype === 'results' ? filter.isVAdatefiltered ? filter.vaDate : null : null
    } else if (filter.isTabPage) {
      params.page = -1,
        params.name = filter.tabSearch,
        params.standardIds = [selectedClassroom?.id];
      params.syllabus = [filter.selectedSyllabus];
      params.subjectId = selectedSubject.isCombined ? null : selectedSubject.subjectId;
      params.chapterId = filter.selectedSyllabus === 'Chapter Test' ? filter.selectedChapter.chapterId : null;
      params.combined = selectedSubject.isCombined ? true : null;
      params.testDate = (type === "results-published" || type === "results-to-publish") ? null : filter.isTAdatefiltered ? filter.taDate : null
      params.resultDate = (type === "results-published" || type === "results-to-publish") ? filter.isTAdatefiltered ? filter.taDate : null : null
      params.testType = filter.testTypeSelector
    }
    return Api.get(`/testv2/tests-by-stage?stage=${type}`).params(params).send((response) => {
      if (response !== undefined) {
        if (type == "ready") {
          dispatch(updateTestToPublish(response.tests));
        }
        else if (type == "results-published") {
          dispatch(updatePublishedResult(response.tests))
        }
        else if (type == "results-to-publish") {
          dispatch(updateResultsData(response.tests))
        }
        else if (type === 'draft') {
          dispatch(updateDrafts(response.tests))
        }
        else if (type === 'ongoing') {
          dispatch(updateOngoingTest(response.tests))
        }
        else if (type === 'upcoming') {
          dispatch(updateUpcomingTests(response.tests))
        }
        else if (type === "submitted") {
          dispatch(updateSubmittedTests(response.tests))
        }
        else if (type === "feedback") {
          dispatch(updateFeedbackFromTeacher(response.tests))
        } else if (type === 'review') {
          dispatch(updateTestsToReview(response.tests))
        } else if (type == 'cancelled') {
          dispatch(updateCancelledTest(response.tests))
        }
        dispatch(universalLoader('GET_RESULTS_LOADER', 'getResultsBool', false));
        dispatch(setLoader('tabPageLoader', false));
        dispatch(setLoader('vaPageLoader', false));
        callback(false);
      }
    })
  }
}

const updateBarchartData = (data) => ({
  type: UPDATE_BARCHART_DATA,
  data
})

export const fetchPublishedResult = () => {
  return (dispatch, getState) => {
    const params = {

    }
    return Api.get(`/testv2/test-result-published`).send((response, error) => {
      // console.log("fetched Publised Result")
      if (response !== undefined) {
        // console.log("fetched Publised Result", response.tests)
        dispatch(updatePublishedResult(response.tests))
      }
    })
  }
}

const updateStandardWiseBarchartData = (data) => ({
  type: UPDATE_STANDARDWISE_BARCHART_DATA,
  data
})

const monthToVal = {
  "Jan": 1, "Feb": 2, "Mar": 3, "Apr": 4, "May": 5, "Jun": 6, "Jul": 7, "Aug": 8,
  "Sep": 9, "Oct": 10, "Nov": 11, "Dec": 12
}

const updateNodata = (data) => ({
  type: UPDATE_NO_DATA,
  data
})

const compare = (a, b) => {
  if (monthToVal[a.date] < monthToVal[b.date]) {
    return -1;
  }
  if (monthToVal[a.date] > monthToVal[b.date]) {
    return 1;
  }
  return 0;
}

const keynames = { cancelledCount: "Cancelled count", scheduledCount: "Scheduled count", heldCount: "Held count", draftCount: "Draft count", publishedCount: "Published count", chapterTests: "Chapter test", fullTests: "Full test", partTests: "Part test" }
const handleBarchartData = (dispatch, data, filter, userType) => {
  const reformatted_data = []
  let max_val = 0
  if (userType != "dataOperator") {
    for (let i = 0; i < data?.length; i++) {
      for (const key in data[i]) {
        let temp = {}
        if ((key == "chapterTests") || (key == "fullTests") || (key == "partTests")) {
          temp['date'] = filter == "month" ? data[i]['unit'].slice(0, 3) : data[i]['unit']
          temp['name'] = key === 'publishedCount' ? keynames["scheduledCount"] : keynames[key]
          temp['totalCount'] = parseInt(data[i][key])
          max_val = Math.max(parseInt(data[i][key]), max_val)
          reformatted_data.push(temp)
        }
      }
    }
  }
  else {
    for (let i = 0; i < data?.length; i++) {
      for (const key in data[i]) {
        let temp = {}
        if ((key == "draftCount") || (key == "publishedCount")) {
          temp['date'] = filter == "month" ? data[i]['unit'].slice(0, 3) : data[i]['unit']
          temp['name'] = keynames[key];
          temp['totalCount'] = parseInt(data[i][key])
          max_val = Math.max(parseInt(data[i][key]), max_val)
          reformatted_data.push(temp)
        }
      }
    }
  }
  if (max_val == 0) {
    dispatch(updateNodata(true))
  }
  else if (max_val > 0) {
    dispatch(updateNodata(false))
  }
  filter == "month" && reformatted_data.sort(compare);
  return reformatted_data;
}


export const fetchBarChartData = (type, callback) => {
  return (dispatch, getState) => {
    dispatch(setLoader('graphLoader', true));
    const { userType, filter, selectedClassroom } = getState().testAdmin;
    const { isFromClassRoomDetails, selectedSection } = getState().classRoom
    let filter1 = 'week'
    const params = {};
    if (type === 'overall') {

    } else {
      params.standardId = isFromClassRoomDetails ? selectedSection?.id : selectedClassroom?.id
    }
    if (filter.selectedGraphFilter === 'week') {
      params.startDate = filter.graphStartDate;
      params.endDate = filter.graphEndDate
    } else {
      filter1 = 'month'
      params.year = filter.graphYear
    }
    return Api.get(`/testv2/homepage-graph`).params(params).send((response) => {
      if (response !== undefined) {
        let reformatted_data = handleBarchartData(dispatch, response, filter1, userType);
        if (type === 'overall') {
          dispatch(updateBarchartData(reformatted_data));

        } else {
          dispatch(updateStandardWiseBarchartData(reformatted_data))
        }
        callback(false);
        dispatch(setLoader('graphLoader', false));
      }
    })
  }
}


export const clearTestCreateObj = () => ({
  type: CLEAR_TEST_CREATE_OBJ,
})

// ---------------------------------------------------------------------------
// Aulas AI -> create test handoff
//
// The generation screen speaks in names from its own JEE/NEET corpus; POST /test
// wants numeric ids scoped to a standard. Subject resolves immediately because
// subject autocomplete does not need a standard. Chapters cannot: chapter
// autocomplete is scoped by standardId, and the AI's "class" is an exam class
// (11 / 12 / Both), not an aulas batch ("11 - A"). So the chapter names are
// parked until the teacher picks a batch in the create form, at which point the
// form has already fetched that batch's chapters for its own dropdown and the
// match runs against the list that is already in the store — no extra request,
// and no second code path that could disagree with the dropdown.
// ---------------------------------------------------------------------------

export const prefillTestCreateObj = (values) => ({
  type: PREFILL_TEST_CREATE_OBJ,
  values,
});

export const setAiHandoff = (values) => ({
  type: SET_AI_HANDOFF,
  values,
});

export const clearAiHandoff = () => ({
  type: CLEAR_AI_HANDOFF,
});

// Corpus names and institute names rarely match byte for byte -- "Laws of
// Motion" vs "LAWS OF MOTION" vs "Ch 5 - Laws of Motion". Compare on lowercase
// alphanumerics with any leading chapter/unit number stripped, which absorbs
// case, punctuation and the numbering prefix most institutes type.
const normaliseChapterName = (name) =>
  String(name ?? '')
    .toLowerCase()
    .replace(/^(chapter|chap|ch|unit|lesson)[\s.\-:)]*\d+[\s.\-:)]*/, '')
    .replace(/[^a-z0-9]/g, '');

// Instructions is also required, and it is the only place the weightage and
// difficulty the teacher chose can survive -- POST /test has no field for
// either. Writing them here keeps that choice visible on the paper instead of
// discarding it at the handoff.
const buildAiInstructions = (selection, generatedTest) => {
  const lines = [];
  const count =
    (Array.isArray(generatedTest?.questions) && generatedTest.questions.length) ||
    parseInt(selection?.n_questions, 10) ||
    0;
  if (count) lines.push(`This paper has ${count} question${count === 1 ? '' : 's'}.`);
  if (selection?.difficulty) lines.push(`Overall difficulty: ${selection.difficulty}.`);
  if (selection?.duration_mins) lines.push(`Suggested duration: ${selection.duration_mins} minutes.`);
  const allocation = generatedTest?._metadata?.allocation;
  if (allocation && Object.keys(allocation).length) {
    lines.push('Questions per chapter:');
    Object.entries(allocation).forEach(([chapter, n]) => lines.push(`  ${chapter}: ${n}`));
  } else if (Array.isArray(selection?.chapters) && selection.chapters.length) {
    lines.push(`Chapters covered: ${selection.chapters.join(', ')}.`);
  }
  const marking = generatedTest?.marking_scheme;
  if (marking && marking.correct !== undefined) {
    lines.push(
      `Marking: +${marking.correct} for a correct answer, ${marking.incorrect} for an incorrect answer, ${marking.unattempted} if unattempted.`
    );
  }
  return lines.join('\n');
};

// Step one of the handoff: resolve the subject, seed the create form, and park
// the chapter names. Runs from the generation screen, before navigating.
export const startAiTestHandoff = (selection, generatedTest, callback) => {
  return (dispatch) => {
    dispatch(setLoader('aiHandoffLoader', true));
    const rawSubject = selection?.subject;
    const selectedSubs = Array.isArray(rawSubject)
      ? rawSubject.filter(Boolean)
      : (rawSubject ? [rawSubject] : []);
    const subjectDisplayName = selectedSubs.join(', ');

    const resolveSubject = (searchSubj) =>
      new Promise((resolve) => {
        if (!searchSubj) {
          resolve(null);
          return;
        }
        Api.get(
          `/testv2/subject/autocomplete?name=${encodeURIComponent(searchSubj)}&standardId=`
        ).send((response) => {
          const list = Array.isArray(response) ? response : [];
          const target = normaliseChapterName(searchSubj);
          // Only a subject whose name matches. Taking the first suggestion regardless filed a Banking paper's
          // English Language and Reasoning Ability under Quantitative Aptitude.
          const hit =
            list.find((item) => normaliseChapterName(item?.value) === target) ||
            list.find((item) => {
              const name = normaliseChapterName(item?.value);
              return name && target && (name.includes(target) || target.includes(name));
            }) ||
            // One subject asked and one suggested ("Maths" for "Mathematics"): nothing to confuse it with.
            (selectedSubs.length === 1 && list.length === 1 ? list[0] : null);
          resolve(hit || null);
        });
      });

    Promise.all(selectedSubs.map(resolveSubject)).then((found) => {
      // Two sections never share one subject: the later one counts as missing.
      const seenIds = new Set();
      const resolvedSubjects = found.map((s) => {
        if (!s || seenIds.has(String(s.id))) return null;
        seenIds.add(String(s.id));
        return s;
      });
      dispatch(setLoader('aiHandoffLoader', false));
      const validSubjects = resolvedSubjects.filter(Boolean);
      const subjectNames = validSubjects.map((s) => s.value);
      const subjectIds = validSubjects.map((s) => '' + s.id);
      const chapterNames = Array.isArray(selection?.chapters) ? selection.chapters : [];

      const sections = generatedTest?.sections || [];
      const subjectSectionList = resolvedSubjects.map((s, index) => {
        if (!s) return null;
        // The server refuses questions past a subject's count ("Reached maximum number of questions for the
        // section"), so each subject must find its own section even when the institute names it a little
        // differently from the generator.
        const target = normaliseChapterName(s.value);
        const asked = normaliseChapterName(selectedSubs[index]);
        const matchingSection =
          sections.find((sec) => [target, asked].includes(normaliseChapterName(sec.subject))) ||
          sections.find((sec) => {
            const name = normaliseChapterName(sec.subject);
            return name && (name.includes(target) || target.includes(name));
          });
        const sectionQCount = matchingSection?.question_ids?.length;
        const fallbackCount = selectedSubs.length > 0
          ? Math.floor((parseInt(selection?.n_questions, 10) || 0) / selectedSubs.length)
          : undefined;
        return {
          name: s.value,
          id: '' + s.id,
          totalQuestions: sectionQCount || fallbackCount || undefined,
        };
      }).filter(Boolean);
      // A Banking paper spans three subjects; one the institute does not have is named on the create form
      // so it can be added there. Its question count goes with it, for the subject's limit.
      const missingSubjects = selectedSubs
        .filter((_, index) => !resolvedSubjects[index])
        .map((name) => {
          const key = normaliseChapterName(name);
          const section = sections.find((sec) => normaliseChapterName(sec.subject) === key);
          // Its topics, which become its chapters when the subject is added.
          const topics = Array.from(new Set(
            (generatedTest?.questions || [])
              .filter((q) => normaliseChapterName(q?.subject) === key)
              .map((q) => String(aiChapterNameOf(q) || '').trim())
              .filter(Boolean)
          ));
          return { name, totalQuestions: section?.question_ids?.length, topics };
        });

      dispatch(clearTestCreateObj());
      // Only carry over a title the teacher typed; otherwise leave it blank.
      const aiTitle = (selection?.title && selection.title.trim()) || '';
      // Chosen on the review screen for a Board set holding both kinds; the
      // questions handed over are already only the kept ones.
      const testType = ['Objective', 'Subjective', 'Mixed'].includes(selection?.testType)
        ? selection.testType
        : 'Objective';
      const handedQuestions = Array.isArray(generatedTest?.questions) ? generatedTest.questions : [];
      const subjectiveCount = handedQuestions.filter(isAiWrittenQuestion).length;
      // A passage goes over as one question, but each of its parts is a question to the teacher.
      const questionCount = handedQuestions.reduce(
        (sum, q) => sum + (isAiComprehension(q) ? aiSubQuestionsOf(q).length : 1),
        0
      );
      // Every chapter was ticked on the generation screen.
      const fullSyllabus = !!selection?.fullSyllabus && chapterNames.length > 0;
      dispatch(
        prefillTestCreateObj({
          testType,
          title: aiTitle,
          syllabus: fullSyllabus ? 'Full' : chapterNames.length > 1 ? 'Part' : 'Chapter',
          subjectName: subjectNames.length > 0 ? subjectNames : (subjectDisplayName ? [subjectDisplayName] : []),
          subjectId: subjectIds,
          instruction: '',
        })
      );
      dispatch(setSubjectSectionAction(subjectSectionList));
      dispatch(
        setAiHandoff({
          active: true,
          subjectName: subjectDisplayName,
          subjectResolved: validSubjects.length > 0,
          // Only when some subject did resolve: with none, the single-subject warning already covers it.
          missingSubjects: validSubjects.length > 0 ? missingSubjects : [],
          titleProvided: !!aiTitle,
          // A Full test carries no chapter list, so there is nothing to match.
          pendingChapterNames: fullSyllabus ? [] : chapterNames,
          matchedChapterNames: [],
          unmatchedChapterNames: [],
          resolved: fullSyllabus || chapterNames.length === 0,
          fullSyllabus,
          fullChapterCount: fullSyllabus ? chapterNames.length : 0,
          questionCount,
          objectiveCount: questionCount - subjectiveCount,
          subjectiveCount,
          testType,
          questionTypes: Array.isArray(selection?.question_types) ? selection.question_types : [],
          generatedTest,
        })
      );
      if (callback) callback(validSubjects.length > 0);
    });
  };
};

// Adds the generated chapters the institute does not have to its syllabus, then
// re-reads the chapter list so the new rows can be attached to the test.
//
// This writes to the institute's curriculum, not just to this test -- the new
// chapters show up in classrooms and in every later test for that subject. So
// it is never automatic: the create form offers it as an explicit action and
// names exactly what will be added.
export const createAiChapters = (callback, customSubjectId) => {
  return (dispatch, getState) => {
    const { testCreateObj, aiHandoff } = getState().testAdmin;
    const names = (aiHandoff?.unmatchedChapterNames || []).filter(Boolean);
    const standardIds = testCreateObj?.standardId;
    let targetSubjectId = customSubjectId;
    if (!targetSubjectId) {
      if (aiHandoff?.subjectName && Array.isArray(testCreateObj?.subjectName) && Array.isArray(testCreateObj?.subjectId)) {
        const idx = testCreateObj.subjectName.findIndex(
          (s) => s && s.toString().trim().toLowerCase() === aiHandoff.subjectName.toString().trim().toLowerCase()
        );
        if (idx !== -1 && testCreateObj.subjectId[idx]) {
          targetSubjectId = testCreateObj.subjectId[idx];
        }
      }
      if (!targetSubjectId) {
        targetSubjectId = Array.isArray(testCreateObj?.subjectId) ? testCreateObj?.subjectId[0] : testCreateObj?.subjectId;
      }
    }
    const standardId = Number(Array.isArray(standardIds) ? standardIds[0] : standardIds);
    const subjectId = Number(targetSubjectId);
    if (!names.length || !Number.isFinite(standardId) || !Number.isFinite(subjectId)) {
      if (callback) callback(false);
      return;
    }
    dispatch(setLoader('aiChapterCreateLoader', true));
    // The standard service reads element.chapterName; plain strings save blank names.
    return Api.post(`/subjects/create-chapters`)
      .params({ standardId, subjectId, chapters: names.map((chapterName) => ({ chapterName })) })
      .send((response) => {
        if (response === undefined || response?.show?.type === 'error') {
          dispatch(setLoader('aiChapterCreateLoader', false));
          if (callback) callback(false);
          return;
        }
        // The create response does not carry the new ids, so re-read the list
        // the chapter dropdown uses and match against that -- same call, same
        // data as everywhere else in this flow.
        Api.get(`/testv2/chapter/autocomplete`)
          .params({ standardId: standardIds, subjectIds: testCreateObj?.subjectId, name: null })
          .send((chapters) => {
            dispatch(setLoader('aiChapterCreateLoader', false));
            if (chapters === undefined) {
              if (callback) callback(false);
              return;
            }
            const cleanChapters = Array.isArray(chapters)
              ? chapters.filter((c) => c?.name && c.name.trim() !== '')
              : chapters;
            dispatch(updateChapterForCreatingTest(cleanChapters));
            dispatch(updateGroupedChapterForCreatingTest(cleanChapters, false, undefined));
            // Re-arm the names so the normal matching step picks up the rows
            // that now exist.
            dispatch(setAiHandoff({ pendingChapterNames: names, unmatchedChapterNames: [] }));
            dispatch(resolveAiChapters(cleanChapters));
            // A 200 from create-chapters does not prove the rows landed under
            // the subject and standard this test is using, so report on what
            // actually came back rather than on the status code.
            const present = new Set(chapters.map((chapter) => normaliseChapterName(chapter?.name)));
            const added = names.filter((name) => present.has(normaliseChapterName(name)));
            const missing = names.filter((name) => !present.has(normaliseChapterName(name)));
            if (callback) callback(true, { added, missing });
          });
      });
  };
};

// Creates `topics` as chapters of one subject in one batch, then reloads the chapters of every subject on
// the test. POST /test refuses a Full test while any of its subjects has no chapter in the batch ("There
// are no chapters in some of the subjects for this class"). `callback({ ok })`.
export const createAiSubjectChapters = (subjectId, standardId, topics, callback) => {
  return (dispatch, getState) => {
    const names = Array.isArray(topics) ? topics.filter(Boolean) : [];
    const reload = () => {
      const { testCreateObj } = getState().testAdmin;
      dispatch(getTestChapterList(null, testCreateObj.subjectId, false, testCreateObj?.standardId?.length ? testCreateObj.standardId : String(standardId)));
    };
    if (!names.length || !standardId || !subjectId) {
      reload();
      if (callback) callback({ ok: false });
      return;
    }
    dispatch(setLoader('aiChapterCreateLoader', true));
    Api.post(`/subjects/create-chapters`)
      .params({ standardId: Number(standardId), subjectId: Number(subjectId), chapters: names.map((chapterName) => ({ chapterName })) })
      .suppressSnackbar()
      .send((res) => {
        dispatch(setLoader('aiChapterCreateLoader', false));
        reload();
        if (callback) callback({ ok: res !== undefined && res?.show?.type !== 'error' });
      });
  };
};

export const fetchAllInstituteStandards = (callback) => {
  return (dispatch) => {
    return Api.get('/standards').params({ courseId: null }).send((response) => {
      let list = [];
      const dataObj = response?.data || response;
      if (Array.isArray(dataObj)) {
        list = dataObj;
      } else if (dataObj && typeof dataObj === 'object') {
        Object.keys(dataObj).forEach((key) => {
          if (key === 'summary') return;
          const val = dataObj[key];
          if (Array.isArray(val)) {
            list.push(...val);
          } else if (val && typeof val === 'object' && val.id) {
            list.push(val);
          }
        });
      }
      if (callback) callback(list);
    });
  };
};

// `append`: the test already has its other subjects (a Banking paper missing one of its three), so the
// new subject joins them instead of replacing them, and `chapterNames` are created as its chapters;
// `onChapters({ ok, added })` reports that step.
export const createAiSubject = (subjectName, standardId, standardLabel, callback, { append = false, totalQuestions, chapterNames, onChapters } = {}) => {
  return (dispatch, getState) => {
    if (!subjectName || !standardId) {
      if (callback) callback(false);
      return;
    }
    dispatch(setLoader('aiSubjectCreateLoader', true));
    return Api.post('/subjects/create-subjects')
      .params({
        standardId: Number(standardId),
        subjects: [subjectName]
      })
      .send((response) => {
        if (response === undefined || response?.show?.type === 'error') {
          dispatch(setLoader('aiSubjectCreateLoader', false));
          if (callback) callback(false);
          return;
        }

        const resolveWithSubject = (subjId, subjVal) => {
          const subjIdStr = String(subjId);
          const subjValStr = String(subjVal || subjectName);
          if (append) {
            const { storeSubjectSection, testCreateObj, aiHandoff } = getState().testAdmin;
            dispatch(storeCreateTestModalData('subjects', { name: subjValStr, id: subjIdStr }));
            const current = Array.isArray(storeSubjectSection) ? storeSubjectSection : [];
            if (!current.some((s) => String(s?.id) === subjIdStr)) {
              dispatch(setSubjectSectionAction([...current, { name: subjValStr, id: subjIdStr, totalQuestions }]));
            }
            dispatch(setAiHandoff({
              missingSubjects: (aiHandoff?.missingSubjects || []).filter((m) => m.name !== subjectName)
            }));
            // A question is filed under its subject through a chapter, so a new subject with none cannot
            // hold questions. Its generated topics become its chapters: the questions then match by name.
            // They go into the test's batch, which is what POST /test checks.
            const testStd = Array.isArray(testCreateObj?.standardId) ? testCreateObj.standardId[0] : testCreateObj?.standardId;
            dispatch(createAiSubjectChapters(subjIdStr, testStd || standardId, chapterNames, onChapters));
            return;
          }
          dispatch(storeCreateTestModalData('subjects', { name: subjValStr, id: subjIdStr }));
          dispatch(setSubjectSectionAction([{ name: subjValStr, id: subjIdStr }]));
          dispatch(storeCreateTestModalData('standardId', String(standardId)));
          if (standardLabel) {
            dispatch(storeCreateTestModalData('class', standardLabel));
          }
          dispatch(setAiHandoff({
            subjectResolved: true,
            subjectName: subjValStr
          }));
          dispatch(getTestClassList([subjIdStr]));
          dispatch(getTestChapterList(subjIdStr, String(standardId)));
          dispatch(getSubjects('', String(standardId)));
        };

        const target = String(subjectName).trim().toLowerCase();

        // Check if the POST response directly returned the created subject
        let createdFromPost = null;
        if (Array.isArray(response?.data)) {
          createdFromPost = response.data.find(
            (s) => String(s?.name || s?.value || s?.subjectName || '').trim().toLowerCase() === target
          ) || response.data[0];
        } else if (response?.data?.id) {
          createdFromPost = response.data;
        }

        if (createdFromPost?.id) {
          dispatch(setLoader('aiSubjectCreateLoader', false));
          resolveWithSubject(createdFromPost.id, createdFromPost.name || createdFromPost.value || subjectName);
          if (callback) callback(true, createdFromPost);
          return;
        }

        // Otherwise query autocomplete for standardId
        Api.get(`/testv2/subject/autocomplete?name=${encodeURIComponent(subjectName)}&standardId=${standardId}`)
          .send((subjectsList) => {
            dispatch(setLoader('aiSubjectCreateLoader', false));
            const list = Array.isArray(subjectsList) ? subjectsList : (Array.isArray(subjectsList?.data) ? subjectsList.data : []);
            const matched = list.find((item) => String(item?.value || item?.name || '').trim().toLowerCase() === target) || list[0];
            if (matched?.id) {
              resolveWithSubject(matched.id, matched.value || matched.name);
              if (callback) callback(true, matched);
            } else {
              if (callback) callback(true, null);
            }
          });
      });
  };
};

// ---- Generated questions -> POST /test/test-question ----------------------
//
// POST /test only creates the shell. Questions go in one at a time through a
// second endpoint, and the two services describe a question very differently:
// the generator returns plain text with a correct_answer LETTER, aulas stores
// HTML with a `correct` flag on the option itself.

const AI_OPTION_LETTERS = ['A', 'B', 'C', 'D', 'E', 'F'];

const escapeHtml = (text) =>
  String(text ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

// questionContent.statement and each option value are HTML -- the question
// screen renders them through ReactHtmlParser with KaTeX math rendering.
// Generated text is plain, so wrap it in <p>. **word** marks bold text.
const toQuestionHtml = (text) =>
  `<p>${escapeHtml(text).replace(/\*\*([^*\n]+?)\*\*/g, '<strong>$1</strong>').replace(/\n/g, '<br/>')}</p>`;

const buildAiStatement = (question) => {
  let html = toQuestionHtml(question?.question ?? question?.text ?? question?.statement ?? '');
  const colA = question?.column_a || question?.columnA || question?.list_1 || question?.list1;
  const colB = question?.column_b || question?.columnB || question?.list_2 || question?.list2;
  if (Array.isArray(colA) && Array.isArray(colB) && colA.length > 0 && colB.length > 0) {
    let listHtml = '<div style="display:flex;gap:20px;margin-top:12px;margin-bottom:12px;">';
    listHtml += '<div style="flex:1;"><strong>List 1:</strong><br/>' + colA.map((item) => escapeHtml(item)).join('<br/>') + '</div>';
    listHtml += '<div style="flex:1;"><strong>List 2:</strong><br/>' + colB.map((item) => escapeHtml(item)).join('<br/>') + '</div>';
    listHtml += '</div>';
    html += listHtml;
  }
  // The diagram file stays on the generation host. Re-hosting it on aulas needs
  // either CORS on those files or a server-side fetch, so for now the image is
  // referenced where it lives -- visible to students, but dependent on that host.
  const url = question?.diagram?.absolute_url;
  if (url) html += `<p><img src="${url}" alt="Diagram" /></p>`;
  return html;
};

// A case-based question is a passage plus numbered parts; the editor has a
// single statement field, so the parts are listed under the passage.
const AI_ROMAN_NUMERALS = ['i', 'ii', 'iii', 'iv', 'v', 'vi', 'vii', 'viii', 'ix', 'x'];

const aiSubQuestionsOf = (question) =>
  Array.isArray(question?.sub_questions) ? question.sub_questions.filter(Boolean) : [];

const buildAiSubjectiveStatement = (question) => {
  let html = buildAiStatement(question);
  aiSubQuestionsOf(question).forEach((sub, index) => {
    const marks = sub?.marks !== undefined && sub?.marks !== null ? ` (${sub.marks} ${Number(sub.marks) === 1 ? 'mark' : 'marks'})` : '';
    html += toQuestionHtml(`(${AI_ROMAN_NUMERALS[index] || index + 1}) ${sub?.question ?? ''}${marks}`);
  });
  return html;
};

const buildAiSubjectiveSolution = (question) => {
  const parts = [];
  const answer = question?.model_answer || question?.correct_answer || question?.answer;
  if (answer) parts.push(toQuestionHtml(answer));
  aiSubQuestionsOf(question).forEach((sub, index) => {
    if (sub?.answer) parts.push(toQuestionHtml(`(${AI_ROMAN_NUMERALS[index] || index + 1}) ${sub.answer}`));
  });
  const points = Array.isArray(question?.marking_points) ? question.marking_points.filter(Boolean) : [];
  if (points.length) {
    parts.push(`<p><strong>Marking points</strong></p><ul>${points.map((p) => `<li>${escapeHtml(p)}</li>`).join('')}</ul>`);
  }
  const explanation = question?.explanation || question?.solution;
  if (explanation && explanation !== answer) parts.push(toQuestionHtml(explanation));
  return parts.length ? parts.join('') : null;
};

// The generation form's Question Types map onto aulas question types one for
// one, except matrix match, which aulas has no equivalent for -- it imports as
// an MCQ so the content survives, but the grid has to be rebuilt by hand.
const AI_TYPE_MAP = {
  single_mcq: 'MCQ',
  multi_correct_mcq: 'MSQ',
  integer_type: 'Numeric',
  matrix_match: 'MCQ',
  assertion_reason: 'MCQ',
};

// The CBSE Board pattern's written types, saved as Subjective questions.
const AI_WRITTEN_TYPES = ['subjective', 'short_answer_2', 'short_answer_3', 'long_answer', 'case_based'];

const isAiWrittenQuestion = (question) =>
  AI_WRITTEN_TYPES.includes(String(question?.type ?? question?.question_type ?? '').toLowerCase());

// Evidence in order of how much it can be trusted: the question's own label, a
// question with no options at all, the type the teacher ticked on the generation
// form when they ticked exactly one, and finally the shape of the answer.
const aiQuestionType = (question, selectedTypes) => {
  const declared = String(question?.type ?? question?.question_type ?? '').toLowerCase();
  // Board written answers have no options and are graded by hand. Checked first:
  // left to the rules below they would fall through to Numeric.
  if (AI_WRITTEN_TYPES.includes(declared)) return 'Subjective';
  // A kind only the Scan PDF screen names (the generator never does), so it is taken as given. (A passage is
  // handled before this, by buildAiComprehensionParams.)
  if (declared === 'true_false') return 'T/F';
  const chosen = (selectedTypes || []).filter(Boolean);
  // If the teacher ticked exactly one question type on the form,
  // that selection is authoritative over generator discrepancies (e.g. LLM defaulting to single_mcq).
  if (chosen.length === 1 && AI_TYPE_MAP[chosen[0]]) return AI_TYPE_MAP[chosen[0]];
  if (declared.includes('integer') || declared.includes('numeric')) return 'Numeric';
  if (declared.includes('matrix')) return 'MCQ';
  if (AI_TYPE_MAP[declared]) return AI_TYPE_MAP[declared];
  if (declared.includes('multi')) return 'MSQ';
  if (declared.includes('single') || declared.includes('mcq')) return 'MCQ';
  if (question?.column_a || question?.columnA || question?.correct_mapping) return 'MCQ';
  if (!Array.isArray(question?.options) || question.options.length === 0) return 'Numeric';
  if (chosen.includes('integer_type') && /^-?\d+(\.\d+)?$/.test(String(question?.correct_answer ?? question?.answer ?? '').trim())) {
    return 'Numeric';
  }
  return correctLettersOf(question).length > 1 ? 'MSQ' : 'MCQ';
};

// The generator is not consistent about what it calls the chapter field, and
// some responses omit it entirely.
const aiChapterNameOf = (question) =>
  question?.chapter ?? question?.chapter_name ?? question?.chapterName ?? question?.topic ?? '';

const correctLettersOf = (question) =>
  String(question?.correct_answer ?? question?.answer ?? '')
    .toUpperCase()
    .replace(/[^A-Z]/g, '')
    .split('')
    .filter(Boolean);

// A comprehension question holds its passage and sub-questions in one. Each sub-question is typed the way the
// question screen types them (CMCQ, CMSQ, CNumeric, CTF) and carries its own marks. The server needs one type
// across a passage, so the Scan PDF screen only sends passages whose questions all share one.
const AI_SUB_TYPE = { single_mcq: 'CMCQ', multi_correct_mcq: 'CMSQ', integer_type: 'CNumeric', true_false: 'CTF' };

const buildAiSubQuestion = (sub) => {
  const key = sub?.question_type;
  const content = { statement: buildAiStatement(sub) };
  let answer;
  if (key === 'single_mcq' || key === 'multi_correct_mcq') {
    const correct = correctLettersOf(sub);
    content.options = (sub?.options || []).map((value, index) => ({
      id: index,
      value: toQuestionHtml(typeof value === 'object' ? JSON.stringify(value) : value),
      correct: correct.includes(AI_OPTION_LETTERS[index]),
    }));
    answer = key === 'multi_correct_mcq' ? { answers: [] } : { answer: null };
  } else if (key === 'integer_type') {
    answer = { answer: sub?.correct_answer ?? null };
  } else {
    answer = { answer: String(sub?.correct_answer ?? '').toLowerCase() === 'true' };
  }
  return {
    answer,
    sub: {
      type: AI_SUB_TYPE[key] || 'CMCQ',
      questionContent: content,
      solution: sub?.explanation || null,
      positiveMarks: Number(sub?.marks) || 0,
      negativeMarks: Math.abs(Number(sub?.negative_marks)) || 0,
    },
  };
};

const isAiComprehension = (question) =>
  String(question?.type ?? question?.question_type ?? '').toLowerCase() === 'comprehensive' &&
  aiSubQuestionsOf(question).length > 0;

// The passage is the question; the parts' marks add up to the passage's marks.
const buildAiComprehensionParams = (question, context) => {
  const built = aiSubQuestionsOf(question).map(buildAiSubQuestion);
  const subQuestions = built.map((b) => b.sub);
  const chapterId = context.chapterIdFor(question);
  return {
    type: 'Comprehensive',
    testId: context.testId,
    sectionId: context.sectionIdFor(chapterId),
    chapterId,
    solution: question?.explanation || null,
    positiveMarks: subQuestions.reduce((sum, s) => sum + s.positiveMarks, 0),
    negativeMarks: subQuestions.reduce((sum, s) => sum + s.negativeMarks, 0),
    questionContent: {
      paragraph: question?.paragraph_html || toQuestionHtml(question?.paragraph ?? ''),
      subQuestions,
    },
    answerContent: built.map((b) => b.answer),
  };
};

const buildAiQuestionParams = (question, context) => {
  if (isAiComprehension(question)) return buildAiComprehensionParams(question, context);
  const type = aiQuestionType(question, context.selectedTypes);
  const correct = correctLettersOf(question);
  const chapterId = context.chapterIdFor(question);
  const params = {
    type,
    testId: context.testId,
    sectionId: context.sectionIdFor(chapterId),
    chapterId,
    solution: question?.explanation || question?.solution || null,
    positiveMarks:
      Number(
        question?.marks ??
        context.markingByType?.[question?.question_type]?.correct ??
        context.markingByType?.single_mcq?.correct ??
        context.marking?.correct ??
        0
      ) || 0,
    // Negative marking is entered as a magnitude in the marking scheme UI, but
    // the generator reports it signed (-1).
    negativeMarks: Math.abs(
      Number(
        question?.negative_marks ??
        context.markingByType?.[question?.question_type]?.incorrect ??
        context.markingByType?.single_mcq?.incorrect ??
        context.marking?.incorrect ??
        0
      )
    ) || 0,
  };
  if (type === 'T/F') {
    params.questionContent = { statement: buildAiStatement(question) };
    params.answerContent = { answer: String(question?.correct_answer ?? '').toLowerCase() === 'true' };
    return params;
  }
  if (type === 'Subjective') {
    // Same shape the question editor saves for a Subjective question: statement
    // only, the model answer as the solution. The review screen has already filled
    // in marks for any that arrived without them; negative marks only when the
    // paper set some (Scan PDF lets the teacher give them, the generator never does).
    params.positiveMarks = Number(question?.marks) || 0;
    params.negativeMarks = Math.abs(Number(question?.negative_marks)) || 0;
    params.questionContent = { statement: buildAiSubjectiveStatement(question) };
    params.answerContent = {};
    params.solution = buildAiSubjectiveSolution(question);
    return params;
  }
  if (type === 'Numeric') {
    params.questionContent = { statement: buildAiStatement(question) };
    params.answerContent = { answer: question?.correct_answer ?? question?.answer ?? null };
    return params;
  }
  let options = (question?.options || []).map((value, index) => ({
    id: index,
    value: toQuestionHtml(typeof value === 'object' ? JSON.stringify(value) : value),
    // Correctness lives on the option, not in answerContent -- that is how the
    // question editor stores an MCQ answer.
    correct: correct.includes(AI_OPTION_LETTERS[index]),
  }));
  if (options.length === 0 && (question?.column_a || question?.correct_mapping)) {
    const mapping = question?.correct_mapping;
    const mappingStr = mapping && typeof mapping === 'object'
      ? Object.entries(mapping).map(([k, v]) => `${k} → ${Array.isArray(v) ? v.join(', ') : v}`).join('; ')
      : (question?.correct_answer || 'Matrix Match');
    options = [{ id: 0, value: toQuestionHtml(mappingStr), correct: true }];
  }
  params.questionContent = {
    statement: buildAiStatement(question),
    options,
  };
  params.answerContent = type === 'MSQ' ? { answers: [] } : { answer: null };
  return params;
};

// Posted one at a time and in order, because that is the only endpoint there is.
// Sequential rather than parallel so a partial failure stops at a known point
// and the test's question order matches the generated paper.
export const importAiQuestions = (test, handoff, chapterList, callback) => {
  return (dispatch) => {
    const questions = handoff?.generatedTest?.questions;
    const marking = handoff?.generatedTest?.marking_scheme || null;
    const selectedTypes = handoff?.questionTypes || [];
    // A subject the test does not have cannot hold its questions: sent anyway they would be filed under
    // another subject and fill it. They are left out and named instead.
    const missing = new Set((handoff?.missingSubjects || []).map((m) => normaliseChapterName(m.name)));
    const all = Array.isArray(questions) ? questions : [];
    const list = all.filter((q) => !missing.has(normaliseChapterName(q?.subject)));
    const skipped = all.length - list.length;
    const skippedSubjects = (handoff?.missingSubjects || []).map((m) => m.name);
    const testId = test?.id;
    if (!testId || !list.length) {
      if (callback) callback({ created: 0, failed: 0, reassigned: 0, unresolved: [], skipped, skippedSubjects });
      return;
    }
    const chapters = Array.isArray(chapterList) ? chapterList : [];

    // A question is filed under its subject through its chapter: the question
    // post carries no subject. In a test with several subjects (a Banking paper
    // has three) each question must take a chapter of its own subject, or it
    // lands in whichever subject owns the chapter it was given.
    const chaptersBySubject = new Map();
    chapters.forEach((chapter) => {
      const key = normaliseChapterName(chapter?.subjectName);
      if (!key) return;
      if (!chaptersBySubject.has(key)) chaptersBySubject.set(key, []);
      chaptersBySubject.get(key).push(chapter);
    });
    const paperSubjects = new Set(list.map((q) => normaliseChapterName(q?.subject)).filter(Boolean));
    const chaptersOfSubject = (question) => {
      const key = normaliseChapterName(question?.subject);
      if (!key || paperSubjects.size < 2) return chapters;
      if (chaptersBySubject.has(key)) return chaptersBySubject.get(key);
      // Institute and generator may name a subject a little differently.
      const loose = [...chaptersBySubject.keys()].find((other) => other.includes(key) || key.includes(other));
      // A subject with no chapters gets none: another subject's chapter would file the question there.
      return loose ? chaptersBySubject.get(loose) : [];
    };

    let reassigned = 0;
    const unresolvedNames = new Set();
    const chapterIdFor = (question) => {
      const pool = chaptersOfSubject(question);
      const raw = aiChapterNameOf(question);
      const key = normaliseChapterName(raw);
      if (key) {
        const exact = pool.find((chapter) => normaliseChapterName(chapter?.name) === key);
        if (exact) return exact.id;
        // Institute names often carry the corpus name plus extra words --
        // "Relations and Functions (Set Theory)". Accept either containing the
        // other before giving up.
        const loose = pool.find((chapter) => {
          const other = normaliseChapterName(chapter?.name);
          return other && (other.includes(key) || key.includes(other));
        });
        if (loose) return loose.id;
      }
      // With one chapter there is nothing to disambiguate: the question belongs
      // to it whatever the generator called it.
      if (pool.length === 1) return pool[0].id;
      const fallbackChapterId = pool[0]?.id ?? null;
      // Better to land the question on the wrong chapter, where it is visible
      // and a teacher can repoint it, than to drop it silently -- but say so.
      if (fallbackChapterId !== null) {
        reassigned += 1;
        if (raw) unresolvedNames.add(String(raw));
      }
      return fallbackChapterId;
    };

    // A test created from this flow has no sections, so sectionId is null -- the
    // same value the question screen uses for an unsectioned subject. When a
    // subject does have sections, use the first of the chapter's own subject.
    const testSubjects = Array.isArray(test?.subjects) ? test.subjects : [];
    const sectionIdFor = (chapterId) => {
      const chapter = chapters.find((c) => c.id === chapterId);
      const subject = (chapter && testSubjects.find((s) => String(s?.subjId ?? s?.id) === String(chapter.subjectId))) ||
        testSubjects[0];
      return subject?.sections?.length ? subject.sections[0].sectionId : null;
    };

    const markingByType = handoff?.generatedTest?.marking_scheme_by_type || null;
    const context = { testId, sectionIdFor, marking, markingByType, chapterIdFor, selectedTypes };
    dispatch(setLoader('aiImportLoader', true));
    dispatch(setLoader('aiImportProgress', { done: 0, total: list.length }));

    let created = 0;
    let failed = 0;
    let latest = null;
    let firstError = null;

    const step = (index) => {
      if (index >= list.length) {
        dispatch(setLoader('aiImportLoader', false));
        dispatch(setLoader('aiImportProgress', null));
        if (latest) {
          // Only the question list. generateQuesObj must keep the object
          // postTestCreate stored -- it carries testType and the test's
          // chapters, and the question screen reads both from it: a non
          // 'Objective' testType there replaces the question type dropdown
          // with a disabled "Subjective type", and the chapter dropdown is
          // built from the same object. The question-create response is a
          // narrower shape, so storing it here blanks both.
          const reformatted = reformat_response({ ...latest });
          dispatch(updateListOfQuestions(reformat_response(injectQuestionIndex(reformatted))));
        } else if (created > 0) {
          Api.get(`/testv2/test-by-id-admin/${testId}?questions=0`).send((response) => {
            if (Array.isArray(response?.subjects)) {
              dispatch(updateListOfQuestions(injectQuestionIndex(reformat_response({ ...response }))));
            }
          });
        }
        if (callback) callback({ created, failed, reassigned, unresolved: [...unresolvedNames], firstError, skipped, skippedSubjects });
        return;
      }
      const params = buildAiQuestionParams(list[index], context);
      // One request per question: silence the per-request snackbar so the user
      // sees only the test-created one (plus the form's own failure summary).
      Api.post(`/test/test-question`).params(params).suppressSnackbar().send((response, errorBody) => {
        // A refusal comes back as HTTP 500: Api.js then passes no response and the body as the second
        // argument. A 2xx carrying show.type 'error' is treated the same way.
        if (response === undefined || response?.show?.type === 'error') {
          failed += 1;
          const message = (errorBody || response)?.show?.message;
          if (!firstError && message) firstError = typeof message === 'string' ? message : message?.description || message?.title || null;
        } else {
          created += 1;
          // Only a reply carrying the question list can refresh the list; any other is re-read at the end.
          latest = Array.isArray(response?.subjects) ? response : null;
        }
        dispatch(setLoader('aiImportProgress', { done: index + 1, total: list.length }));
        step(index + 1);
      });
    };
    step(0);
  };
};

// Step two: match the parked chapter names against the chapters the create form
// has already loaded for the chosen batch. `available` is the store's own
// chaptersForCreatingTest, so this never disagrees with the chapter dropdown.
// `loadedEmpty`: the list really came back empty for this batch (not just
// "not loaded yet"), so every pending name is unmatched.
export const resolveAiChapters = (available, loadedEmpty = false) => {
  return (dispatch, getState) => {
    const { aiHandoff } = getState().testAdmin;
    const pending = aiHandoff?.pendingChapterNames || [];
    if (!pending.length) return;
    const list = Array.isArray(available) ? available : [];
    if (!list.length && !loadedEmpty) return;

    const byName = new Map();
    list.forEach((chapter) => {
      const key = normaliseChapterName(chapter?.name);
      if (key && !byName.has(key)) byName.set(key, chapter);
    });

    const matched = [];
    const unmatched = [];
    pending.forEach((name) => {
      const hit = byName.get(normaliseChapterName(name));
      if (hit) matched.push(hit);
      else unmatched.push(name);
    });

    // storeCreateTestModalData already de-dupes chapters by id.
    matched.forEach((chapter) => {
      dispatch(
        storeCreateTestModalData('chapters', {
          id: chapter.id,
          name: chapter.name,
          subjectId: chapter.subjectId,
        })
      );
    });

    dispatch(
      setAiHandoff({
        pendingChapterNames: [],
        matchedChapterNames: matched.map((chapter) => chapter.name),
        unmatchedChapterNames: unmatched,
        resolved: true,
      })
    );
  };
};
export const storeGenerateQuestionsObj = (res) => ({
  type: STORE_GENERATE_QUESTIONS_OBJ,
  res,
})

export const postTestCreate = (callback, success, sectionValue) => {
  console.log("errrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr")
  return (dispatch, getState) => {
    dispatch(universalLoader('POST_TEST_CREATE', 'universalLoaderBool', true));
    const { testCreateObj, createTestModalName, generateQuesObj, listViewType, storeSubjectSection, aiHandoff } = getState().testAdmin;
    // A Full test from Scan PDF or Aulas AI still loads its chapters, so each imported question can be filed under its
    // own one, but the test itself is sent as any Full test is: with no chosen chapters.
    const fullFromHandoff = aiHandoff?.active && testCreateObj.syllabus === 'Full';
    let isClassScreen = window.location.pathname == '/test-std-to-subjects-screen' ? true : false;
    const params = {
      // chapterIds: [1274, 1272],
      // chapterNames: ["Fractions", "Understanding Elementary Shapes"],
      // cloneTestId: null,
      // id: 21,
      // status: "Draft",
      // sub: undefined,
      // subjectId: -1,
      index: testCreateObj.tIndex,
      instructions: testCreateObj.instruction,
      selectedTeacher: testCreateObj.teacherId,
      standardIds: typeof testCreateObj.standardId == "string" ? [testCreateObj.standardId] : testCreateObj.standardId,
      testDate: moment(testCreateObj.heldDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      startTime: testCreateObj.heldStartTime,
      endTime: testCreateObj.heldEndTime,
      // subjectIds: testCreateObj.subjectId,
      // subjectNames: testCreateObj.subjectName,
      teacherId: testCreateObj.teacherId,
      teacherName: testCreateObj.teacherName,
      title: testCreateObj.title,
      testType: testCreateObj.testType,
      syllabus: testCreateObj.syllabus === 'Chapter' ? 'Chapter Test' : testCreateObj.syllabus === 'Full' ? 'Full Test' : testCreateObj.syllabus === 'Part' ? 'Part Test' : '',
      chosenChapterIds: fullFromHandoff ? [] : testCreateObj.chapterList?.map((item) => item.id),
      subjectsSection: storeSubjectSection,
      sectionValue: sectionValue

    }
    if (testCreateObj.testType === 'Objective') {
      params.resultDate = moment(testCreateObj.resultDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
      params.resultTime = testCreateObj.resultTime;
    }
    if (createTestModalName === 'test-edit') {
      params.id = generateQuesObj.id
    }
    else if (createTestModalName == 'test-clone') {
      params.cloneTestId = generateQuesObj.id
    }
    if (params.id) {
      delete params.id
    }
    return Api.post(`/test`).params(params).send(response => {
      console.log("yrk", params)
      success()
      dispatch(universalLoader('POST_TEST_CREATE', 'universalLoaderBool', false));
      if (response != undefined && response.show.type !== 'error') {
        if (createTestModalName === 'test-create') {
          dispatch(clearGenerateQuesFields());
        }
        dispatch(clearTestCreateObj());
        dispatch(storeGenerateQuestionsObj(response));
        dispatch(updateListOfQuestions(injectQuestionIndex(response)));

        if ((response.testType === 'Subjective')) {
          setTimeout(() => {
            dispatch(getMarkingSchemeMarks(response.testType))
          }, 3001)
        }
        callback(response);
      }
    });
  }
}

export const postTestSeries = (callback, success, sectionValue) => {
  console.log("errrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr")
  return (dispatch, getState) => {
    dispatch(universalLoader('POST_TEST_CREATE', 'universalLoaderBool', true));
    const { testCreateObj, createTestModalName, generateQuesObj, listViewType, storeSubjectSection } = getState().testAdmin;
    let isClassScreen = window.location.pathname == '/test-std-to-subjects-screen' ? true : false;
    const params = {
      // chapterIds: [1274, 1272],
      // chapterNames: ["Fractions", "Understanding Elementary Shapes"],
      // cloneTestId: null,
      // id: 21,
      // status: "Draft",
      // sub: undefined,
      // subjectId: -1,
      index: testCreateObj.tIndex,
      instructions: testCreateObj.instruction,
      selectedTeacher: testCreateObj.teacherId,
      standardIds: typeof testCreateObj.standardId == "string" ? [testCreateObj.standardId] : testCreateObj.standardId,
      testDate: moment(testCreateObj.heldDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      startTime: testCreateObj.heldStartTime,
      endTime: testCreateObj.heldEndTime,
      // subjectIds: testCreateObj.subjectId,
      // subjectNames: testCreateObj.subjectName,
      teacherId: testCreateObj.teacherId,
      teacherName: testCreateObj.teacherName,
      title: testCreateObj.title,
      testType: testCreateObj.testType,
      syllabus: testCreateObj.syllabus === 'Chapter' ? 'Chapter Test' : testCreateObj.syllabus === 'Full' ? 'Full Test' : testCreateObj.syllabus === 'Part' ? 'Part Test' : '',
      chosenChapterIds: testCreateObj.chapterList?.map((item) => item.id),
      subjectsSection: storeSubjectSection,
      sectionValue: sectionValue

    }
    if (testCreateObj.testType === 'Objective') {
      params.resultDate = moment(testCreateObj.resultDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
      params.resultTime = testCreateObj.resultTime;
    }
    if (createTestModalName === 'test-edit') {
      params.id = generateQuesObj.id
    }
    else if (createTestModalName == 'test-clone') {
      params.cloneTestId = generateQuesObj.id
    }
    if (params.id) {
      delete params.id
    }
    return Api.post(`/testSeries/createTest`).params(params).send(response => {
      console.log("yrk", params)
      success()
      dispatch(universalLoader('POST_TEST_CREATE', 'universalLoaderBool', false));
      if (response != undefined && response.show.type !== 'error') {
        if (createTestModalName === 'test-create') {
          dispatch(clearGenerateQuesFields());
        }
        dispatch(clearTestCreateObj());
        dispatch(storeGenerateQuestionsObj(response));
        dispatch(updateListOfQuestions(injectQuestionIndex(response)));

        if ((response.testType === 'Subjective')) {
          setTimeout(() => {
            dispatch(getMarkingSchemeMarks(response.testType))
          }, 3000)
        }
        callback(response);
      }
    });
  }
}
export const postTestEdit = (sectionValue, callback, success) => {
  return (dispatch, getState) => {
    dispatch(universalLoader('POST_TEST_CREATE', 'universalLoaderBool', true));
    const { testCreateObj, createTestModalName, generateQuesObj, listViewType, storeSubjectSection, schemeId } = getState().testAdmin;
    let isClassScreen = window.location.pathname == '/test-std-to-subjects-screen' ? true : false;
    const params = {
      // chapterIds: [1274, 1272],
      // chapterNames: ["Fractions", "Understanding Elementary Shapes"],
      // cloneTestId: null,
      // id: 21,
      // status: "Draft",
      // sub: undefined,
      // subjectId: -1,
      index: testCreateObj.tIndex,
      instructions: testCreateObj.instruction,
      selectedTeacher: testCreateObj.teacherId,
      standardIds: typeof testCreateObj.standardId === "object" ? testCreateObj.standardId : [testCreateObj.standardId],
      testDate: moment(testCreateObj.heldDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      startTime: testCreateObj.heldStartTime,
      endTime: testCreateObj.heldEndTime,
      // subjectIds: testCreateObj.subjectId,
      // subjectNames: testCreateObj.subjectName,
      teacherId: testCreateObj.teacherId,
      teacherName: testCreateObj.teacherName,
      title: testCreateObj.title,
      testType: testCreateObj.testType,
      syllabus: testCreateObj.syllabus === 'Chapter' ? 'Chapter Test' : testCreateObj.syllabus === 'Full' ? 'Full Test' : testCreateObj.syllabus === 'Part' ? 'Part Test' : '',
      chosenChapterIds: testCreateObj.chapterList?.map((item) => item.id),
      subjectsSection: storeSubjectSection,
      sectionValue

    }
    if (testCreateObj.resultDate && testCreateObj.resultDate !== 'Invalid date') {
      params.resultDate = moment(testCreateObj.resultDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
      params.resultTime = testCreateObj.resultTime;
    }
    if (createTestModalName === 'test-edit') {
      params.id = generateQuesObj.id
    }
    else if (createTestModalName == 'test-clone') {
      params.cloneTestId = generateQuesObj.id
    }
    return Api.post(`/test`).params(params).send(response => {
      callback();
      dispatch(universalLoader('POST_TEST_CREATE', 'universalLoaderBool', false));
      if (response != undefined && response.show.type !== 'error') {
        if (success) {
          success();
        }
        // if(createTestModalName === 'test-create'){
        //   dispatch(clearGenerateQuesFields());
        // }
        dispatch(storeGenerateQuestionsObj(response));
        dispatch(updateListOfQuestions(injectQuestionIndex(response)));
        if (response.testType === 'Subjective') {
          setTimeout(() => {
            dispatch(getMarkingSchemeMarks(response.testType))
          }, 3000)
        }

      }
    });
  }
}

export const getSubjectsName = (res) => ({
  type: GET_SUBJECTS_NAME,
  res,
});
export const getSubjects = (text, standardId) => {
  return (dispatch, getState) => {
    dispatch(setLoader('modalSubjectLoader', true));
    const { testCreateObj } = getState().testAdmin;
    return Api.get(`/testv2/subject/autocomplete?name=${text}&standardId=${standardId}`).send(response => {
      console.log("response sub", response)
      if (response != undefined) {
        dispatch(getSubjectsName(response));
        dispatch(setLoader('modalSubjectLoader', false));
      }
    });
  }
}

export const removeSelectedSearchSubjs = (index, text) => ({
  type: REMOVE_SELECTED_SEARCHED_SUBJS,
  index,
  text
});
export const getExaminerName = (res) => ({
  type: GET_EXAMINER_NAME,
  res,
});
export const getExaminer = (text) => {
  return (dispatch) => {
    dispatch(universalLoader('GET_EXAMINER_LOADER', 'getExaminerBool', true));
    return Api.get(`/user/autocomplete?role=Teacher&name=${text}&includeSuperAdmin=1`).send(response => {
      dispatch(universalLoader('GET_EXAMINER_LOADER', 'getExaminerBool', false));
      // console.log('response getExaminer+++', response);
      if (response != undefined) {
        dispatch(getExaminerName(response));
      }
    });
  }
}

const updateOngoingTest = ongoingTests => ({
  type: UPDATE_ONGOING_TEST,
  ongoingTests
})


const updateDrafts = drafts => ({
  type: UPDATE_DRAFTS,
  drafts
})


const updateSubjectsByClass = data => ({
  type: UPDATE_SUBJECTS_BY_CLASS,
  data
})

export const fetchClassSubjects = (standardId, callback) => {
  return (dispatch) => {
    return new Promise((resolve) => {
      Api.get(`/testv2/test-standard?standardId=${standardId}`).send((response) => {
        if (response !== undefined) {
          resolve();
          dispatch(updateSyllabus(response.syllabuses));
          dispatch(updateSubjectsByClass(response.subjects ? response.subjects : []));
          dispatch(updateTodayActivities(response));
          callback(false);
          dispatch(setLoader('syllabusPageLoader', false));
        }
      })
    })
  }
}

export const setSelectedSubject = data => ({
  type: SET_SELECTED_SUBJECT,
  data
})

export const updateTodayActivities = data => ({
  type: UPDATE_TODAY_ACTIVITY,
  data
})


export const fetchTestSubmitDetails = (callback) => {
  return (dispatch, getState) => {
    dispatch(setLoader('studentSearchLoader', true));
    const { submittedTestsId, filter } = getState().testAdmin;
    return Api.get(`/testv2/test-submit-details?testId=${submittedTestsId}&search=${filter?.studentSearch}`).send((response, error) => {
      // console.log("Response ",response )
      if (response !== undefined) {
        dispatch(updateSubmittedTestsDetails(response.test))
        dispatch(updateSubmittedTestsUsers(response.users))
        dispatch(updateSubmittedTestsAbsentStudents(response.absentStudents))
      }
      callback(false)
      dispatch(setLoader('studentSearchLoader', false));
    })
  }
}

const reformatted_questions = (subjects) => {
  let c = 0
  for (let subject of subjects) {
    if (subject?.sections && subject?.sections?.length > 0) {
      for (let section of subject?.sections) {
        for (let question of section.questions) {
          c += 1
          question.index = c
        }
      }
    } else {
      for (let question of subject.questions) {
        c += 1
        question.index = c
      }
    }
  }
  return [c, subjects]
}
//Fetching questions array for Question grid
export const fetchSubmittedTestQuestionsForQueGrid = (callback, type) => {
  return (dispatch, getState) => {
    dispatch(universalLoader('GET_EVALUATION_PAGE_LOADER', 'getEvaluationPageBool', true));
    const { submittedTestsId, submittedTestsStudentsId } = getState().testAdmin
    return Api.get(`/test/student/submit-test?testId=${submittedTestsId}&studentId=${submittedTestsStudentsId}&question=0`).send((response, error) => {
      //dispatch(universalLoader('GET_EVALUATION_PAGE_LOADER', 'getEvaluationPageBool', false));
      if (response !== undefined) {
        let [questionCount, subjects] = reformatted_questions(response.subjects);
        if (type === 'fromResult') {
          dispatch(updateEvaluationQuestionId(response.subjects?.length && response.subjects[0].questions?.length ? response.subjects[0].questions[0] : 0))
        }
        dispatch(updateSubmittedTestsByStudentId({ ...response, questionCount: questionCount }))
        dispatch(updateTotalMarksObtained(parseFloat(response.totalMarksObatined != null ? response.totalMarksObatined : '0')));
        dispatch(updateQuestionGridsArray(subjects));
        callback(false)
      }
    })
  }
}

//Save entire evaluated test
export const saveEntireEvaluatedTest = (callback) => {
  return (dispatch, getState) => {
    dispatch(universalLoader('GET_EVALUATION_PAGE_LOADER', 'getEvaluationPageBool', true));
    const { submittedTestsStudentsId,
      submittedTestsId,
      submittedTestsByStudentId,
      totalMarksObtained
    } = getState().testAdmin


    const params = {
      testId: submittedTestsId,
      totalMarks: totalMarksObtained,
      studentId: submittedTestsStudentsId,
      // totalMarksObatined: 50
    }



    return Api.post(`/test/review-test`).params(params).send(response => {
      dispatch(universalLoader('GET_EVALUATION_PAGE_LOADER', 'getEvaluationPageBool', false));
      if (response != undefined) {
        callback(false)
      }
    });
  }
}

//Save evaluation of Admin/Teacher
export const saveEvaluation = (callback, answerstatus) => {
  return (dispatch, getState) => {
    dispatch(universalLoader('GET_EVALUATION_PAGE_LOADER', 'getEvaluationPageBool', true));
    const { evaluationQuestionId,
      evaluatedMark,
      evaluatedComment,
      submittedTestsStudentsId,
      submittedTestsId,
    } = getState().testAdmin


    const params = {
      testQuestionId: evaluationQuestionId.id,
      score: (evaluatedMark == null || evaluatedMark == "None") ? 0 : evaluatedMark,
      comment: evaluatedComment,
      status: answerstatus,
      studentId: submittedTestsStudentsId,
      testId: submittedTestsId,
    }

    return Api.post(`/test/review-test`).params(params).send(response => {
      // console.log('response postQuestionCreate', response);
      if (response != undefined) {
        callback(false)
      }
    });
  }
}

const getObj = (index, subjects) => {
  console.log('subjectGetObj', subjects)
  for (let subject of subjects) {
    if (subject?.sections && subject?.sections?.length > 0) {
      for (let section of subject?.sections) {
        for (let question of section?.questions) {
          if (index === question.index) {
            return {
              "id": question.id,
              "answerStatus": question.answerStatus,
              "submitStatus": question.submitStatus
            }
          }
        }
      }
    } else {
      for (let question of subject.questions) {
        if (index === question.index) {
          return {
            "id": question.id,
            "answerStatus": question.answerStatus,
            "submitStatus": question.submitStatus
          }
        }
      }
    }
  }
}

export const increaseQuestionId = (callback) => {
  return (dispatch, getState) => {
    const { evaluationQuestionId, evaluationPageQuestionGrid, currentQuestionIndex } = getState().testAdmin;
    const obj = getObj(currentQuestionIndex + 1, evaluationPageQuestionGrid)

    dispatch(updateEvaluationQuestionId(obj))
    // dispatch(updatePostEvaluationObject())
    callback(true)
  }
}

//Fetching question by it's id for evaluation page
export const fetchSubmittedTestQuestionUsingQuestionId = (callback) => {
  return (dispatch, getState) => {
    dispatch(universalLoader('GET_EVALUATION_PAGE_LOADER', 'getEvaluationPageBool', true));
    const { submittedTestsId, submittedTestsStudentsId, evaluationQuestionId, currentQuestionIndex } = getState().testAdmin
    // console.log("See currentQuestionIndex", currentQuestionIndex)
    return Api.get(`/testv2/get-student-answer-by-id?testId=${submittedTestsId}&studentId=${submittedTestsStudentsId}&index=${currentQuestionIndex + 1}`).send((response, error) => {
      dispatch(universalLoader('GET_EVALUATION_PAGE_LOADER', 'getEvaluationPageBool', false));
      if (response !== undefined) {
        dispatch(updateEvaluationQuestionId(response));
        dispatch(updateEvaluationQuestionData(response))
        dispatch(updateEvaluatedMark(parseFloat(response.marksObtained != null ? response.marksObtained : 0)))
        dispatch(updateEvaluatedComment(response.comment == null ? '' : response.comment))
        callback(false)
      }
    })
  }
}


//Fetching questions array for list view
export const fetchSubmittedTestByStudentId = (callback) => {
  return (dispatch, getState) => {
    dispatch(universalLoader('GET_EVALUATION_PAGE_LOADER', 'getEvaluationPageBool', true));
    const { submittedTestsId, submittedTestsStudentsId, } = getState().testAdmin
    return Api.get(`/test/student/submit-test?testId=${submittedTestsId}&studentId=${submittedTestsStudentsId}&question=${1}`).send((response, error) => {
      dispatch(universalLoader('GET_EVALUATION_PAGE_LOADER', 'getEvaluationPageBool', false));
      if (response !== undefined) {
        console.log('listViewRes', response)
        let [questionCount, subjects] = reformatted_questions(response.subjects);
        dispatch(updateSubmittedTestsByStudentId({ ...response, subjects: subjects, questionCount: questionCount }));
        callback(false)
      }
    })
  }
}

export const updateTodayResults = (res) => ({
  type: UPDATE_TODAY_RESULTS,
  res
})

export const fetchTodayTest = (type, callback, searchText) => {
  return (dispatch, getState) => {
    const { filter } = getState().testAdmin;
    const params = {
      name: filter.TAsearch,
      syllabus: filter.TAsyllabus,
      standardIds: filter.TAclasses,
      page: filter.TApage
    }
    dispatch(setLoader('taPageLoader', true));
    dispatch(universalLoader('GET_RESULTS_LOADER', 'getResultsBool', true));
    return Api.get(`/testv2/test-filter-today?filter=${type}`).params(params).send((response) => {
      if (response !== undefined) {
        // console.log("fetched today test", type, response.tests);
        if (type == 'Cancelled') {
          dispatch(updateCancelledTest(response.tests))
        }
        else if (type == 'Ongoing') {
          dispatch(updateOngoingTest(response.tests))
        }
        else if (type == 'Upcoming') {
          dispatch(updateUpcomingTests(response.tests))
        }
        else if (type == "Submitted") {
          dispatch(updateSubmittedTests(response.tests))
        } else if (type == "Results") {
          dispatch(updateTodayResults(response.tests))
        }
        // console.log("exiting from something");
        callback(false);
        dispatch(universalLoader('GET_RESULTS_LOADER', 'getResultsBool', false));
        dispatch(setLoader('taPageLoader', false));
      }
      callback(false);
    })
  }
}


const updateUpcomingTests = data => ({
  type: UPDATE_UPCOMING_TESTS,
  data
})
// const updateSubmittedTests = data=>({
//   type: UPDATE_SUBMITTED_TESTS,
//   data
// })

const getTestNames = (data) => ({
  type: GET_TEST_NAME_ARR,
  data,
});

const updateStudentResults = (data) => ({
  type: UPDATE_STUDENT_RESULT,
  data
})

export const fetchStudentResults = (testId = 1, callback) => {
  return (dispatch, getState) => {
    dispatch(setLoader('studentSearchLoader', true));
    const { filter } = getState().testAdmin;
    return Api.get(`/testv2/test-submit-details?testId=${testId}&search=${filter?.studentSearch}`).send((response) => {
      if (response !== undefined) {
        dispatch(updateStudentResults(response))
        callback(false);
        dispatch(setLoader('studentSearchLoader', false));
      }
    })
  }
}

const storeMarkingSchemeData = (res) => ({
  type: STORE_MARKING_SCHEME_DATA,
  res

})

export const fetchMarkingSchemeData = () => {
  return (dispatch, getState) => {
    // dispatch(setLoader('studentSearchLoader', true));
    const { testCreateObj } = getState().testAdmin;
    const params = {
      orgurl: Api?._headers?.orgurl,
      testType: testCreateObj?.testType
    }
    return Api.get(`/marking-scheme/autocomplete`).params(params).send((response) => {
      if (response !== undefined) {
        dispatch(storeMarkingSchemeData(response))
        // callback(false);
        // dispatch(setLoader('studentSearchLoader', false));
      }
    })
  }
}
const updateOneStudentResult = (data) => ({
  type: UPDATE_ONE_STUDENT_RESULT,
  data
})
export const fetchOneStudentResult = (testId = null, studentId = null, callback) => {
  return (dispatch) => {
    return Api.get(`/testv2/get-each-student-result?testId=${testId}&studentId=${studentId}`).send((response) => {
      if (response !== undefined) {
        // console.log("fetched one student result", response)
        dispatch(updateOneStudentResult(response))
        callback(false);
      }
    })
  }
}


export const updateSelectedTest = (data) => ({
  type: UPDATE_SELECTED_TEST,
  data
})

export const updateSelectedTestId = (data) => ({
  type: UPDATE_SELECTED_TEST_ID,
  data
})

export const updateSelectedStudent = (data) => ({
  type: UPDATE_SELECTED_STUDENT,
  data
})

export const updateCancelledTest = (data) => ({
  type: UPDATE_CANCELLED_TESTS,
  data
})



export const actOnSelectedTest = (testid, type, callback) => {
  return () => {
    let status = "";
    if (type == "Delete") {
      status = "Deleted"
    }
    else if (type == "Publish") {
      status = "Published"
    } else if (type == "Cancel") {
      status = "Cancelled"
    }
    else if ((type == "Unpublish") || type == "Draft") {
      status = "Draft"
    }
    const params = {
      status: status
    }
    // console.log("the test id is", testid, "the status is", status)
    return Api.post(`/test/editstatus/${testid}`).params(params).send((response, error) => {
      if (response !== undefined && response?.show?.type !== "error") {
        if (callback) {
          callback()
        }
      }
    })
  }
}
export const getIndexOfTest = () => {
  return (dispatch, getState) => {
    dispatch(setLoader('indexLoader', true));
    dispatch(universalLoader('GET_INDEX_OF_TEST', 'getIndexOfTestBool', true));
    const { testCreateObj } = getState().testAdmin;
    const standardId = testCreateObj.standardId;
    const subIds = testCreateObj.subjectId;
    let syllabus = testCreateObj.syllabus === 'Chapter' ? 'Chapter Test' : testCreateObj.syllabus === 'Part' ? 'Part Test' : testCreateObj.syllabus === 'Full' ? 'Full Test' : '';
    return Api.get(`/testv2/get-index?subjectIds=[${subIds}]&standardId=${standardId}&syllabus=${syllabus}`).send(response => {
      dispatch(universalLoader('GET_INDEX_OF_TEST', 'getIndexOfTestBool', false));
      // console.log('response getExaminer+++', response);
      if (response != undefined) {
        dispatch(storeCreateTestModalData('tIndex', response.index));
        dispatch(setLoader('indexLoader', false));
      }
    });
  }
}

export const showTextEditor = (name, index, val) => ({
  type: SHOW_TEXT_EDITOR,
  name,
  index,
  val
});
export const updateSubWithChapters = (name) => ({
  type: UPDATE_SUB_WITH_CHAPTERS,
  name,
});
export const addMarksForQues = (operation, name, index) => ({
  type: ADD_MARKS_FOR_QUES,
  operation,
  name,
  index
});
export const renderEditorContent = (name, value) => ({
  type: RENDER_EDITOR_CONTENT,
  name,
  value,
});
export const chooseCorrectAnswer = (val, index, identifier) => ({
  type: CHOOSE_CORRECT_ANSWER_ADMIN,
  val,
  index,
  identifier
});

export const chooseBoolAnswer = (val, bool, index) => ({
  type: CHOOSE_BOOL_ANSWER,
  val,
  bool,
  index
});

export const storeTestQuesType = (obj, id, name) => ({
  type: STORE_TEST_QUES_TYPE,
  obj,
  id,
  name,
});
export const updateListOfQuestions = (res) => ({
  type: UPDATE_LIST_OF_QUESTIONS,
  res,
});
export const storeEditorRemovedImgs = (arr) => ({
  type: STORE_EDITOR_REMOVED_IMGS,
  arr,
});
export const storeEditoraddedImgs = (arr) => ({
  type: STORE_EDITOR_ADDED_IMGS,
  arr,
});

export const clearGenerateQuesFields = (val) => ({
  type: CLEAR_GENERATE_QUES_FIELDS,
  val
});

const reformat_response = (response) => {
  for (let i = 0; i < response.subjects?.length; i++) {
    response.subjects[i].comments = [];
    for (let j = 0; j < response.subjects[i].mix?.length; j++) {
      response.subjects[i].comments.push(response.subjects[i].mix[j].remark)
    }
    // response.subjects[i].comments.reverse();
  }
  return response;
}
export const postQuestionCreate = (params, callback) => {
  return (dispatch, getState) => {
    dispatch(universalLoader('POST_QUESTION_CREATE', 'postQuestionCreateBool', true));
    const { questionContent, answerContent, generateQuesObj, generateQuesSelectedTestType, generateSolutionText, quesPositiveMark, quesNegativeMark, generateQuesSelectedChapter, selectedSectionId } = getState().testAdmin;
    // const params = {
    //   questionContent: questionContent,
    //   answerContent: answerContent,
    //   type:generateQuesSelectedTestType.children,
    //   positiveMarks:quesPositiveMark,
    //   negativeMarks:quesNegativeMark,
    //   testId:generateQuesObj.id,
    //   chapterId:generateQuesSelectedChapter.key,
    //   solution:generateSolutionText,
    //   sectionId:selectedSectionId,
    // }
    return Api.post(`/test/test-question`).params(params).send(response => {
      dispatch(universalLoader('POST_QUESTION_CREATE', 'postQuestionCreateBool', false));
      // console.log('response postQuestionCreate', response);
      if (response != undefined) {
        let reformated_response = reformat_response({ ...response });
        dispatch(clearGenerateQuesFields('Post'));
        dispatch(updateListOfQuestions(reformat_response(injectQuestionIndex(reformated_response))));
        dispatch(updateNumericAnswer(''));
      }
    });
  }
}

export const deleteQuillImgs = (callback) => {
  return (dispatch, getState) => {
    dispatch(universalLoader('DELETE_QUILL_IMGS', 'deleteQuillImgsBool', true));
    const { generateQuesRemovedImgs } = getState().testAdmin;

    return Api.delete(`/test/delete-image`).params({ deletedFiles: generateQuesRemovedImgs }).send(response => {
      dispatch(universalLoader('DELETE_QUILL_IMGS', 'deleteQuillImgsBool', false));
      // console.log('response deleteQuillImgs', response);
      if (response != undefined) {
        callback();
      }
    });
  }
}

export const deleteQuesFromServer = (callback) => {
  return (dispatch, getState) => {
    const { editGenerateQueId } = getState().testAdmin;
    return Api.delete(`/test/test-question/${editGenerateQueId}`).send(response => {
      // console.log('response deleteQuesFromServer', response);
      if (response != undefined) {
        if (callback) {
          callback()
        }
        // console.log('DeleteRes',response)
        dispatch(updateListOfQuestions(injectQuestionIndex(response)));
        dispatch(clearGenerateQuesFields());
      }
    });
  }
}

export const resetGenerateQuesFields = (res) => ({
  type: RESET_GENERATE_QUES_FIELDS,
  res,
});
export const storeEditGenerateQueId = (id) => ({
  type: STORE_EDIT_GENERATE_QUE_ID,
  id,
});

export const getEachQuesData = (id) => {
  return (dispatch, getState) => {
    dispatch(universalLoader('GET_EACT_QUES_DATA_LOADER', 'getEachQuesDataBool', true));
    dispatch(storeEditGenerateQueId(id));
    return Api.get(`/test/get-question-by-id/${id}`).send(response => {
      dispatch(universalLoader('GET_EACT_QUES_DATA_LOADER', 'getEachQuesDataBool', false));
      // console.log('response getEachQuesData', response);
      if (response != undefined) {
        dispatch(resetGenerateQuesFields(response))
      }
    });
  }
}

export const publishResult = (testid, callback) => {
  return () => {
    return Api.patch(`/test/status/${testid}`).params({ status: 'Published' }).send((response) => {
      if (response != undefined) {
        // console.log("the response is", response);
        // actOnSelectedTest1(type, callback);
        callback(false);
      }
    })
  }
}

export const PublishTestResult = (testid, callback) => {
  return new Promise((resolve) => {
    Api.patch(`/testv2/declare-result/${testid}`).send((response) => {
      if (typeof (response) !== "undefined") {
        resolve();
        callback(response);
      }
    })
  })
}

export const storeGenerateQuesListView = (res) => ({
  type: STORE_GENERATE_QUES_LIST_VIEW,
  res,
});

export const getTestClassList = (subIds, chapterIds = []) => {
  return (dispatch, getState) => {
    dispatch(setLoader('modalClassLoader', true));
    const params = {
      subjectIdList: subIds,
      chapterIdList: chapterIds
    }
    return Api.get(`/testv2/standard/autocomplete`).params(params).send(response => {
      // dispatch(universalLoader('POST_QUESTION_CREATE', 'postQuestionCreateBool', false));
      dispatch(setLoader('modalClassLoader', false));
      if (response != undefined) {
        dispatch(updateStdForCreatingTest(response));
      }
    });
  }
}

const groupChapters = (chapters) => {
  let groupedChapters = {};
  for (let chapter of chapters) {
    if (chapter.subjectId in groupedChapters) {
      groupedChapters[chapter.subjectId].chapters.push({ ...chapter });
    } else {
      groupedChapters[chapter.subjectId] = {
        subjectId: chapter.subjectId,
        subjectName: chapter.subjectName, chapters: [{ ...chapter }]
      }
    }
  }
  return groupedChapters
}

export const getTestChapterList = (search = null, subjectId = null, iscreate = true, stdid) => {
  return (dispatch, getState) => {
    dispatch(setLoader('modalChapterLoader', true));
    const { testCreateObj } = getState().testAdmin;
    const params = {
      standardId: iscreate == undefined || iscreate === true ? testCreateObj.standardId : stdid,
      subjectIds: subjectId ? subjectId : testCreateObj.subjectId,
      name: search
    };
    if (params.standardId?.length === 0) {
      return
    }
    return Api.get(`/testv2/chapter/autocomplete`).params(params).send(response => {
      if (response != undefined) {
        const cleanResponse = Array.isArray(response)
          ? response.filter((item) => item?.name && item.name.trim() !== '')
          : response;
        dispatch(updateChapterForCreatingTest(cleanResponse));
        dispatch(updateGroupedChapterForCreatingTest(cleanResponse, subjectId != undefined && iscreate ? true : false, subjectId))
      }
      dispatch(setLoader('modalChapterLoader', false));
    });
  }
}

// const injectQuestionIndex = (response) => {
//   let index = 1
//   for (const subject of response?.subjects) {
//     if (subject?.includeSectionFlag && subject?.includeSectionFlag !== 0) {
//       for (let section of subject?.sections) {
//         const newquestions = [];
//         for (let question of section?.questions) {
//           newquestions.push({ id: question, index: index })
//           index += 1
//         }
//         section.questions = newquestions
//       }
//     } else {
//       const newquestions = [];
//       for (let question of subject?.questions) {
//         newquestions.push({ id: question, index: index })
//         index += 1
//       }
//       subject.questions = newquestions

//     }

//   }
//   return response
// }

const injectQuestionIndex = (response, listview) => {
  // A reply without the question list (a refusal, or a different shape) has nothing to number.
  if (!Array.isArray(response?.subjects)) {
    console.warn('injectQuestionIndex: response has no subjects list', response);
    return response;
  }
  let index = 1
  if (listview === 'list') {
    for (const subject of response?.subjects) {
      if (subject?.includeSectionFlag && subject?.includeSectionFlag !== 0) {
        for (let section of subject?.sections || []) {
          const newquestions = [];
          for (let question of section?.questions || []) {
            newquestions.push({ ...question, index: index })
            index += 1
          }
          section.questions = newquestions
        }
      } else {
        const newquestions = [];
        for (let question of subject?.questions || []) {
          newquestions.push({ ...question, index: index })
          index += 1
        }
        subject.questions = newquestions

      }

    }

  } else {
    for (const subject of response?.subjects) {
      if (subject?.includeSectionFlag && subject?.includeSectionFlag !== 0) {
        for (let section of subject?.sections || []) {
          const newquestions = [];
          for (let question of section?.questions || []) {
            newquestions.push({ id: question, index: index })
            index += 1
          }
          section.questions = newquestions
        }
      } else {
        const newquestions = [];
        for (let question of subject?.questions || []) {
          newquestions.push({ id: question, index: index })
          index += 1
        }
        subject.questions = newquestions

      }

    }
  }
  return response
}

export const showGenerateQuesListView = (callback, page_source,) => {
  return (dispatch, getState) => {
    dispatch(universalLoader('GENERATE_QUES_LIST_VIEW_LOADER', 'generateQuesListViewBool', true));
    const { generateQuesObj, selectedTest, importTestIdContainer, schemeId } = getState().testAdmin;
    let id = "";
    let ques = "";
    if (page_source == "listview") {
      id = generateQuesObj.id;
      ques = '';
    } else if (page_source === "navigation") {
      id = generateQuesObj.id;
      ques = 0;
    } else if (page_source === 'import') {
      id = generateQuesObj.id;
      ques = 0;
    } else if (page_source === "importListView") {
      id = importTestIdContainer;
      ques = '';
    } else if (page_source === 'editImportListView') {
      id = importTestIdContainer;
      ques = 0;
    }
    else {
      id = selectedTest.id ? selectedTest.id : selectedTest.testId ? selectedTest.testId : generateQuesObj.id;
      ques = 0;
    }
    return Api.get(`/testv2/test-by-id-admin/${id}?questions=${ques}`).send(response => {
      dispatch(universalLoader('GENERATE_QUES_LIST_VIEW_LOADER', 'generateQuesListViewBool', false));
      if (response != undefined) {
        if (page_source === 'listview' || page_source === 'importListView') {
          dispatch(storeGenerateQuesListView(injectQuestionIndex(response, 'list')));
        } else {
          dispatch(storeGenerateQuesListView(response));
        }
        dispatch(setSubjectSectionAction(response?.subjects))
        console.log('response', response)
        if (page_source != "listview") {
          dispatch(clearGenerateQuesFields())
          if (page_source !== "importListView") {
            dispatch(getTestChapterList(null, response.subjects?.map(item => '' + item.subjId), false, response.standardIds));
          }
          dispatch(storeGenerateQuestionsObj(response));
          dispatch(updateListOfQuestions(injectQuestionIndex(response)));
          if (response.testType === 'Subjective' && page_source !== 'tabview' && schemeId !== null && schemeId > 0) {
            setTimeout(() => {
              dispatch(getMarkingSchemeMarks(response.testType))
            }, 3000)
          }
        }
        if (page_source === 'tabviewlive') {
          callback(response);
        }
        else {
          callback(response.subjectIds?.split(','), response.chapters);
        }
      }
    });
  }
}

export const sendForReview = (testid, callback) => {
  return () => {
    const params = {
      "markedForReview": 1
    }
    return Api.patch(`/test/test-markforreview/${testid}`).params(params).send((response, error) => {
      if (response !== undefined) {
        // actOnSelectedTest1(type, callback);
      }
      callback(false);
    });
  }
}

export const setIsEditModalVisible = (bool) => ({
  type: SET_EDIT_MODAL_VISIBLE,
  data: bool
})

export const setIsCModalVisible = (bool) => ({
  type: SET_C_MODAL_VISIBLE,
  data: bool
})

export const setCModalType = (data) => ({
  type: SET_C_MODAL_TYPE,
  data
})

export const toggleReloaderFlag = () => ({
  type: TOGGLE_RELOADER_FLAG
})
export const createTestModal = (name, user, source) => ({
  type: CREATE_TEST_MODAL,
  name,
  user,
  source
});

export const changeTestStatusModal = (name) => ({
  type: CHANGE_TEST_STATUS_MODAL,
  name,
});

export const setSubjectSectionAction = (val) => ({
  type: SET_SUBJECT_SECTION,
  val
})
export const changeTestStatus = (history, path, comment) => {
  return (dispatch, getState) => {
    dispatch(universalLoader('CHANGE_TEST_STATUS_LOADER', 'changeTestStatusBool', true));
    const { generateQuesObj, modalActiveName, selectedTestId, importTestIdContainer } = getState().testAdmin;
    const testId = (modalActiveName == "MarkReady" || modalActiveName == "SendReview") ? selectedTestId : (modalActiveName == "Published" && path == '2') ? importTestIdContainer : (modalActiveName == "Review" && path == '2') ? generateQuesObj?.test?.id : generateQuesObj.id;

    if (modalActiveName === 'Feedback') {
      return Api.patch(`/test/feedback`).params({ testId, message: comment }).send(response => {
        dispatch(universalLoader('CHANGE_TEST_STATUS_LOADER', 'changeTestStatusBool', false));
        if (response != undefined && response.show.type !== 'error') {
          if (path == "fromClassroom") {
            history.push({ pathname: '/test-std-to-subjects-screen', state: { key: "fromClassroom" } });
          } else {
            history.push('test');
          }
          dispatch(changeTestStatusModal(''));
          dispatch(clearGenerateQuesFields(''));
        }
      });
    }

    const statusParams = { status: modalActiveName == "MarkReady" ? "Ready" : modalActiveName == "SendReview" ? "Review" : modalActiveName };
    return Api.patch(`/test/status/${testId}`).params(statusParams).send(response => {
      dispatch(universalLoader('CHANGE_TEST_STATUS_LOADER', 'changeTestStatusBool', false));
      if (response != undefined && response.show.type !== 'error') {
        if ((modalActiveName == "MarkReady") || (modalActiveName == "SendReview")) {
          dispatch(fetchDashBoardData(() => { }));
          dispatch(fetchTestsByStage("draft", () => { }))
        } else if (path == "fromClassroom") {
          history.push({ pathname: '/test-std-to-subjects-screen', state: { key: "fromClassroom" } });
        }
        else {
          history.push('test');
        }
        dispatch(changeTestStatusModal(''));
        dispatch(clearGenerateQuesFields(''));
      }
    });
  }
}

export const unsetCreateTestModalBool = () => ({
  type: UNSET_CREATE_TEST_MODAL_BOOL
})

export const updateListViewType = (data) => ({
  type: UPDATE_LISTVIEW_TYPE,
  data
})

export const updateFeedbackData = (res) => ({
  type: UPDATE_FEEDBACK_DATA,
  res
})

export const updateReadyToPublish = (data) => ({
  type: UPDATE_READY_TO_PUBLISH,
  data
})

export const updateRole = () => {
  return (dispatch, getState) => {
    const { user } = getState().session;
    dispatch(updateRoleHelper(user));
  }
}

export const updateRoleHelper = (user) => ({
  type: UPDATE_ROLE,
  user
})

export const updateFeedbackFromTeacher = (data) => ({
  type: UPDATE_FEEDBACK_FROM_TEACHER,
  data
})

export const updateOperatorStats = (data) => ({
  type: UPDATE_DATA_OPERATOR_STATS,
  data
})

export const updateTestsToReview = (data) => ({
  type: UPDATE_TESTS_TO_REVIEW,
  data
})

export const updateResultsData = (data) => ({
  type: UPDATE_RESULTS_DATA,
  data
})

export const updateSelectedCardType = (data) => ({
  type: UPDATE_SELECTED_CARD_TYPE,
  data
})

export const updateSubmittedTestsAbsentStudents = (data) => ({
  type: UPDATE_SUBMITTEDTEST_ABSENTSTUDENTS,
  data
})

export const updateTotalMarksObtained = (marks) => ({
  type: UPDATE_TOTAL_MARKS_OBTAINED,
  marks
})

export const updatePalette = (qIndex, newType) => ({
  type: UPDATE_PALETTE_DATA,
  qIndex,
  newType
})

export const updateNumericAnswer = (newAnswer, index) => ({
  type: UPDATE_NUMERIC_ANSWER,
  newAnswer,
  index
})

export const updatePostParams = (newParams) => ({
  type: UPDATE_POST_PARAMS2,
  newParams
})

export const setOpenTab = (tabName) => ({
  type: SET_OPEN_TAB,
  tabName
})

export const updateStdForCreatingTest = (classes) => ({
  type: UPDATE_STD_FOR_CREATING_TEST,
  classes
})

export const updateChapterForCreatingTest = (chapters) => ({
  type: UPDATE_CHAPTER_FOR_CREATING_TEST,
  chapters
})

export const updateGroupedChapterForCreatingTest = (chapterList, isSearch, subjectId) => ({
  type: UPDATE_GROUPED_CHAPTER_FOR_CREATING_TEST,
  chapterList,
  isSearch,
  subjectId
})

export const postComment = (params, callback) => {
  return (dispatch, getState) => {
    return Api.post(`/test/question/comment`).params(params).send(response => {
      // dispatch(universalLoader('GET_EVALUATION_PAGE_LOADER', 'getEvaluationPageBool', false));
      if (response != undefined) {
        console.log("prime res", response);
        let reformated_response = reformat_response({ ...response });
        dispatch(updateListOfQuestions(reformat_response(injectQuestionIndex(reformated_response))));
        callback(response);
      }
    });
  }
}

export const setDashboardMeta = (val) => ({
  type: SET_DASHBOARD_META,
  val
})

export const removeSelectedChapter = (id) => ({
  type: REMOVE_SELECTED_CHAPTER,
  id
});

export const updateSyllabus = (res) => ({
  type: UPDATE_SYLLABUS,
  res
})

export const updateFilter = (key, val) => ({
  type: UPDATE_FILTER,
  key,
  val
})

const handleSubjects = (response, syllabus) => {
  let temp = [];
  for (const sub of response.subjects) {
    temp.push({ ...sub, isCombined: false });
  }
  if (syllabus !== 'Chapter Test') {
    temp.push({
      subjectName: "Combined Test(s)",
      objectiveCount: response.combinedObjective,
      subjectiveCount: response.combinedSubjective,
      mixedCount: response.combinedMixed,
      codingCount: response.combinedCoding,
      icon: response.combinedIcon,
      isCombined: true
    })
  }
  return temp;
}

export const fetchSyllabusSubjects = () => {
  return (dispatch, getState) => {
    dispatch(setLoader('subjectPageLoader', true));
    const { selectedClassroom, filter } = getState().testAdmin;
    const { isFromClassRoomDetails, selectedSection } = getState().classRoom
    const params = {
      standardId: isFromClassRoomDetails ? selectedSection?.id : selectedClassroom?.id,
      syllabus: filter.selectedSyllabus,
      search: filter.subjectSearch
    }
    return Api.get(`/testv2/test-standard-syllabus`).params(params).send(response => {
      if (response != undefined) {
        const subjects = handleSubjects(response, filter.selectedSyllabus);
        dispatch(updateSubjectsByClass(subjects));
        dispatch(setLoader('subjectPageLoader', false));
        console.log("response", response);
      }
    });
  }
}

export const fetchSubjectChapters = (succesCallback = null) => {
  return (dispatch, getState) => {
    dispatch(setLoader('chapterPageLoader', true));
    const { selectedClassroom, filter, selectedSubject } = getState().testAdmin;
    const params = {
      standardId: selectedClassroom.id,
      subjectId: selectedSubject.subjectId,
      search: filter.chapterSearch
    }
    return Api.get(`/testv2/chapter-test-chapters`).params(params).send(response => {
      if (response != undefined) {
        // const subjects = handleSubjects(response, filter.selectedSyllabus);
        // dispatch(updateSubjectsByClass(subjects));
        if (succesCallback) {
          succesCallback(response)
        }
        dispatch(setChaptersList(response));
        dispatch(setLoader('chapterPageLoader', false));
        console.log("response", response);
      }
    });
  }
}

export const postReorderChaptersTest = (chapters, callBack = null, successCallBack = null) =>
  (dispatch, getState) => {
    const { selectedClassroom, filter, selectedSubject } = getState().testAdmin;
    const transformedChapters = chapters.map(({ chapterId, chapterName }) => ({ chapterId, chapterName }))
    const params = {
      subjectName: selectedSubject?.subjectName,
      standardId: selectedClassroom?.id,
      subjectId: selectedSubject.subjectId,
      chapters: transformedChapters
    }
    return Api.post("/subjects/createSubjectV2")
      .params(params)
      .send((response) => {
        if (callBack) {
          callBack();
        }
        if (response !== undefined && response?.show?.type !== 'error') {
          if (successCallBack) {
            successCallBack();
          }
        }
      });
  };

export const setLoader = (key, val) => ({
  type: SET_LOADER,
  key,
  val
})

export const setImportMeta = (key, value) => ({
  type: SET_IMPORT_META,
  key,
  value
})


export const fetchClassByCurrData = (callback = null) => {
  return (dispatch, getState) => {
    // dispatch(setLoader('importClassLoader', true));
    return Api.get('/question-bankv2').send((response, error) => {
      if (callback) {
        callback()
      }
      if (response != undefined) {
        console.log("response class data", response);
        dispatch(setImportMeta('setImportClassroom', response));
        // dispatch(setLoader('importClassLoader', false));
        // callback(false);
      }
    })
  };
}


export const fetchSampleQuestionPaper = (callback = null) => {
  return (dispatch, getState) => {
    // dispatch(setLoader('sampleGroupLoader', true));
    const { importMeta } = getState().testAdmin;
    const params = {
      curriculumId: importMeta.selectedStandardObj?.curriculumId,
      standardId: importMeta.selectedStandardObj?.id,
      questionPaperType: 'sample question paper',
      questionPaperName: ''
    }
    return Api.get(`/question-bankv2/question-paper`).params(params).send((response, error) => {
      if (callback) {
        callback()
      }
      if (response != undefined) {
        console.log("response sample question papers", response)
        dispatch(setImportMeta('setImportSampleQuestionPapers', response));
        // dispatch(setLoader('sampleGroupLoader', false));
      }
    })
  }
}

export const fetchSampleQuestionPaperQuestions = (callback) => {
  return (dispatch, getState) => {
    dispatch(setLoader('sampleQuesLoader', true));
    const { importMeta } = getState().testAdmin;
    // const params = {
    // standardId: importMeta.selectedClassData.standardId,
    // questionPaperType: 'sample question paper',
    // questionPaperName: ''
    // }


    const params = {
      questionPaperId: importMeta.sampleQuestionPaperObj.questionPaperId,
      testImport: true
    }
    return Api.get(`/question-bankv2/questions`).params(params).send((response, error) => {
      if (response != undefined) {
        console.log("response sample question papers", response)
        // dispatch(updateTopicCardData(response))
        dispatch(setImportMeta('setSampleQuestionTree', response));
        callback();
        dispatch(setLoader('sampleQuesLoader', false));
      }
    })
  }
}

const reformat_chapters = (chapters) => {
  let reformatted_chapters = [];
  for (let subject_index of chapters) {
    if (subject_index?.chapters?.length !== 0) {
      for (let chapter of subject_index.chapters) {
        reformatted_chapters.push({ ...chapter, subjectId: subject_index.id, subjectName: subject_index.name });
      }
    }
  }
  return reformatted_chapters;
}

export const getTestSampleQuestionPaperData = (callback = null, successCallBack = null) => {
  return (dispatch, getState) => {
    const { importMeta } = getState().testAdmin;
    const params = {
      questionPaperId: importMeta?.selectedPaperObj?.id
    }
    return Api.get(`/question-bankv2/import/test/sample-question-paper`).params(params).send((response, error) => {
      if (callback) {
        callback()
      }
      if (response != undefined && response?.show?.type !== 'error') {
        dispatch(clearGenerateQuesFields())
        dispatch(storeChapters(reformat_chapters(response.chapters)))
        // dispatch(getTestChapterList(null, response.subjects?.map(item=>''+item.subjId), false, response.standardIds));
        dispatch(storeGenerateQuestionsObj(response));
        // dispatch(updateListOfQuestions(injectQuestionIndex(response))); 
        dispatch(setSubjectSectionAction(response?.subjects))
        if (successCallBack) {
          successCallBack()
        }
      }
    })
  }
}

export const storeChapters = (val) => ({
  type: STORE_CHAPTERS,
  val
})

export const postImportSampleQuestionPaper = (callback, success) => {
  return (dispatch, getState) => {
    dispatch(universalLoader('POST_TEST_CREATE', 'universalLoaderBool', true));
    const { testCreateObj, createTestModalName, generateQuesObj, listViewType, storeSubjectSection, importMeta } = getState().testAdmin;
    let isClassScreen = window.location.pathname == '/test-std-to-subjects-screen' ? true : false;
    const params = {
      // chapterIds: [1274, 1272],
      // chapterNames: ["Fractions", "Understanding Elementary Shapes"],
      // cloneTestId: null,
      // id: 21,
      // status: "Draft",
      // sub: undefined,
      // subjectId: -1,
      questionPaperId: importMeta?.selectedPaperObj?.id,
      index: testCreateObj.tIndex,
      instructions: testCreateObj.instruction,
      selectedTeacher: testCreateObj.teacherId,
      standardIds: typeof testCreateObj.standardId === "object" ? testCreateObj.standardId : [testCreateObj.standardId],
      testDate: moment(testCreateObj.heldDate, 'DD/MM/YYYY').format('YYYY-MM-DD'),
      startTime: testCreateObj.heldStartTime,
      endTime: testCreateObj.heldEndTime,
      // subjectIds: testCreateObj.subjectId,
      // subjectNames: testCreateObj.subjectName,
      teacherId: testCreateObj.teacherId,
      teacherName: testCreateObj.teacherName,
      title: testCreateObj.title,
      testType: testCreateObj.testType,
      syllabus: testCreateObj.syllabus === 'Chapter' ? 'Chapter Test' : testCreateObj.syllabus === 'Full' ? 'Full Test' : testCreateObj.syllabus === 'Part' ? 'Part Test' : '',
      chosenChapterIds: testCreateObj.chapterList?.map((item) => item.id),
      subjectsSection: storeSubjectSection

    }
    if (testCreateObj.resultDate && testCreateObj.resultDate !== 'Invalid date') {
      params.resultDate = moment(testCreateObj.resultDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
      params.resultTime = testCreateObj.resultTime;
    }
    if (createTestModalName === 'test-edit') {
      params.id = generateQuesObj.id
    }
    else if (createTestModalName == 'test-clone') {
      params.cloneTestId = generateQuesObj.id
    }
    return Api.post(`/question-bankv2/import/test/sample-question-paper`).params(params).send(response => {
      callback();
      dispatch(universalLoader('POST_TEST_CREATE', 'universalLoaderBool', false));
      if (response != undefined && response?.show?.type !== 'error') {
        dispatch(storeImportTestId(response?.testId))
        if (success) {
          success();
        }
        // if(createTestModalName === 'test-create'){
        //   dispatch(clearGenerateQuesFields());
        // }
        // dispatch(storeGenerateQuestionsObj(response));
        // dispatch(updateListOfQuestions(injectQuestionIndex(response)));

      }
    });
  }
}

export const storeImportTestId = (val) => ({
  type: STORE_IMPORT_TEST_ID,
  val
})

export const storeListViewData = (val) => ({
  type: STORE_LIST_VIEW_DATA,
  val
})

export const storePageNumber = (val) => ({
  type: STORE_PAGE_NUMBER,
  val
})

export const storeSubjectId = (val) => ({
  type: STORE_SUBJECT_ID,
  val
})

export const storeQuestionPaletteData = (val) => ({
  type: STORE_QUESTION_PALETTE_DATA,
  val
})

export const fetchQuestionPaletteData = (callback, toFirstSubject = true) => {
  return (dispatch, getState) => {
    const { importMeta } = getState().testAdmin;
    const params = {
    }
    // if (qbFullData.qbType === 'sample') {
    //   params.questionPaperId = qbFullData.selectedQuestionPaper?.questionPaperId
    // } else {
    //   params.topicId = qbFullData.selectedTopic?.topicId
    // }
    params.questionPaperId = importMeta?.selectedPaperObj?.id
    return Api.get(`/question-bankv2/question-navigation`).params(params).send((response, error) => {
      if (callback) {
        callback()
      }
      if (response != undefined) {
        dispatch(storeQuestionPaletteData(response));
        dispatch(storeSubjectId(response[0]?.id))
        dispatch(getListViewData(() => { }))
      }
    })
  }
}

export const getListViewData = (callBack = null) => {
  return (dispatch, getState) => {
    const { importMeta, questionPaletteDataConatiner, pageNumber, subjectIdContainer, listViewDataContainer } = getState().testAdmin;
    let data = questionPaletteDataConatiner?.map((item) => {
      return {
        name: item?.name,
        id: item.id
      }
    })
    dispatch(storeSubjectName(data))
    const params = {
    }
    // if (qbFullData.qbType === 'sample') {
    //   params.questionPaperId = qbFullData.selectedQuestionPaper?.questionPaperId
    // } else {
    //   params.topicId = qbFullData.selectedTopic?.topicId
    // }
    params.questionPaperId = importMeta?.selectedPaperObj?.id
    params.limit = 10
    params.page = pageNumber
    params.subjectId = subjectIdContainer
    return Api.get(`/question-bankv2/questionsListView`).params(params).send((response, error) => {
      if (callBack) {
        callBack()
      }
      if (response != undefined) {
        if (listViewDataContainer?.items?.length > 0) {
          let temp = [...response?.items]
          let temp1 = [...listViewDataContainer?.items]
          let temp3 = [...temp1, ...temp]
          let arr = {
            items: temp3,
            meta: response?.meta
          }
          dispatch(storeListViewData(arr))
        } else {
          dispatch(storeListViewData(response))
        }
      }
    })
  }
}

export const storeSubjectName = (val) => ({
  type: STORE_SUBJECT_NAME,
  val
})

export const importSampleQuestionPaper = (callback) => {
  return (dispatch, getState) => {
    dispatch(setLoader('importingSampleQuesLoader', true));
    const { importMeta, generateQuesObj } = getState().testAdmin;
    const params = {
      questionIds: importMeta.sampleIndividualBool ? importMeta.selectedSampleQuestions : [],
      questionPaperIds: importMeta.sampleGroupBool ? importMeta.selectedSampleQuestionPapers : [],
      testId: generateQuesObj?.id
    }
    return Api.post(`/question-bankv2/import/test/question-paper`).params(params).send((response, error) => {
      if (response != undefined) {
        callback(response);
        dispatch(setLoader('importingSampleQuesLoader', false));
      }
    })
  }
}

export const fetchSubjectCardData = (callback) => {
  return (dispatch, getState) => {
    dispatch(setLoader('importSubjectList', true));
    const { importMeta } = getState().testAdmin;
    const params = {
      curriculumId: importMeta.selectedStandardObj?.curriculumId,
      standardId: importMeta.selectedStandardObj?.id,
      questionPaperType: 'subject-wise question paper'
    }
    return Api.get(`/question-bankv2/question-paper`).params(params).send((response, error) => {
      if (response != undefined) {
        console.log("response subjects", response);
        dispatch(setImportMeta('subjectCardData', response));
        callback(false);
        dispatch(setLoader('importSubjectList', false));
      }
    })
  }
}


export const fetchChapterCardData = (callback) => {
  return (dispatch, getState) => {
    dispatch(setLoader('importChapter', true));
    const { importMeta } = getState().testAdmin;
    const params = {
      curriculumId: importMeta.selectedStandardObj?.curriculumId,
      standardId: importMeta.selectedStandardObj?.id,
      subjectId: importMeta.selectedSubjectObj.subId
    }
    return Api.get(`/question-bankv2/chapters`).params(params).send((response, error) => {
      if (response != undefined) {
        console.log("response chapters", response)
        dispatch(setImportMeta('chapterCardData', response));
        dispatch(setLoader('importChapter', false));
        // callback(false);
      }
    })
  }
}


export const fetchTopicList = (callback) => {
  return (dispatch, getState) => {
    dispatch(setLoader('importTopics', true));
    const { importMeta } = getState().testAdmin;
    const params = {
      curriculumId: importMeta?.selectedStandardObj?.curriculumId,
      standardId: importMeta?.selectedStandardObj?.id,
      subjectId: importMeta?.selectedSubjectObj?.subId,
      chapterId: importMeta?.selectedChapterObj?.chapterId
    }
    return Api.get(`/question-bankv2/topics`).params(params).send((response, error) => {
      if (response != undefined) {
        console.log("response chapters", response);
        dispatch(setImportMeta('topicsList', response));
        dispatch(setImportMeta('setSelectionTree', response))
        callback(response);
        dispatch(setLoader('importTopics', false));
        dispatch(setLoader('importSubjectWiseQuestions', false));
      }
    })
  }
}


export const fetchSubjectWiseQuestions = (callback) => {
  return (dispatch, getState) => {
    dispatch(setLoader('importSubjectWiseQuestions', true));
    const { importMeta, generateQuesObj } = getState().testAdmin;
    const params = {
      topicId: importMeta.selectedTopic?.topicId,
      testImport: true
    }
    return Api.get(`/question-bankv2/questions`).params(params).send((response, error) => {
      if (response != undefined) {
        console.log("response subjective question papers", response);
        dispatch(setImportMeta('topicwiseQuestionsList', response));
        dispatch(setLoader('importSubjectWiseQuestions', false));
      }
    })
  }
}

export const setTextFalse = (res) => ({
  type: SET_TEXT_FALSE,
  res
})

export const importSubjectWiseQuestionPaper = (callback) => {
  return (dispatch, getState) => {
    dispatch(setLoader('importingSubQuestions', true));
    const { importMeta, generateQuesObj, selectedSectionId } = getState().testAdmin;
    let questions = [];
    for (let topic of importMeta.selectionTree) {
      for (let questionId of topic.selectedQuestions) {
        questions.push({
          questionId: questionId,
          positiveMarks: importMeta.marksList[questionId]?.positiveMark,
          negativeMarks: importMeta.marksList[questionId]?.negativeMark,
          subQuestionMarks: importMeta.marksList[questionId]?.subQuestionMarks
        })
      }
    }
    const params = {
      questions: questions,
      testId: generateQuesObj.id,
      sectionId: selectedSectionId
    }
    return Api.post(`/question-bankv2/import/test/subjectwise`).params(params).send((response, error) => {
      if (response != undefined) {
        console.log("response sample question papers", response);

        // dispatch(updateTopicCardData(response))
        // dispatch(setImportMeta('setSampleQuestionTree', response));
        // dispatch(setLoader('topicPageLoader', false));
        callback(response);
      }
    })
  }
}


export const getMarkingSchemeData = (search, callBack = null) => {
  console.log(Api._headers, "abcd")
  return (dispatch, getState) => {
    return Api.get("/marking-scheme/allScheme")
      .params({
        orgurl: Api._headers?.orgurl,
        search: search ? search : ''
      })
      .send((response) => {
        if (callBack) {
          callBack()
        }
        if (response != undefined) {
          dispatch(storeMarkingSchemeCardData(response));
          console.log("response", response);
        }
      })
  }
}

export const storeMarkingSchemeCardData = (val) => ({
  type: STORE_MARKING_SCHEME_CARD_DATA,
  val
})

export const searchFilter = (val) => ({
  type: SEARCH_FILTER,
  val
})

export const storeMarkingSchemeTitle = (val) => ({
  type: STORE_MARKING_SCHEME_TITLE,
  val
})

export const storeMarkingSchemeDesc = (val) => ({
  type: STORE_MARKING_SCHEME_DESC,
  val
})

export const storeMarkingSchemeSubjective = (val) => ({
  type: STORE_MARKING_SCHEME_SUBJECTIVE,
  val
})

export const storeMarkingSchemeObjective = (val) => ({
  type: STORE_MARKING_SCHEME_OBJECTIVE,
  val
})

export const postCreateMarkingScheme = (callBack = null, successCallBack) => {
  return (dispatch, getState) => {
    const { markingSchemeTitle, markingSchemeDescription, subjectiveTypeContainer, objectiveTypeContainer, markedSchemeCardIdContainer } = getState().testAdmin;
    const updatedSubjectiveTypeContainer = subjectiveTypeContainer.map((item) => item.positiveMarks ? item : null).filter(Boolean);
    return Api.post("/marking-scheme/addScheme")
      .params({
        title: markingSchemeTitle,
        description: markingSchemeDescription,
        orgurl: Api._headers?.orgurl,
        subjectiveQuestion: updatedSubjectiveTypeContainer,
        objectiveQuestion: objectiveTypeContainer,
        schemeId: markedSchemeCardIdContainer
      })
      .send((response) => {
        console.log("jj", response);
        if (callBack) {
          callBack()
        }
        if (response != undefined) {
          if (successCallBack) {
            successCallBack(response)
          }
          fetchMarkingSchemeDataTS()
        }
      })
  }
}

export const fromCreateNewButton = (bool) => ({
  type: FROM_CREATE_NEW_BUTTON,
  bool
});

export const setFromSectionMarkingScheme = (val) => ({
  type: SET_FROM_SECTION_MARKING_SCHEME,
  val
})

export const getMarkingSchemeCardDetails = (callBack = null) => {
  return (dispatch, getState) => {
    const { markedSchemeCardIdContainer } = getState().testAdmin
    return Api.get("/marking-scheme/fetchDetails")
      .params({ schemeId: markedSchemeCardIdContainer })
      .send((response) => {
        if (callBack) {
          callBack()
        }
        if (response != undefined) {
          dispatch(storeMarkingSchemeTitle(response?.title))
          dispatch(storeMarkingSchemeDesc(response?.description))
          dispatch(storeMarkingSchemeObjective(response?.objectiveQuestion))
          dispatch(storeMarkingSchemeSubjective(response?.subjectiveQuestion))
          dispatch(markedSchemeCardDetails(response))
        }
      })
  }
}

export const getMarkingSchemeCardDetailsTS = (callBack, TSdata) => {
  return (dispatch, getState) => {
    return Api.get("/testSeries/fetchMS")
      .params(TSdata)
      .send((response) => {
        if (callBack) {
          callBack()
        }
        if (response != undefined) {
          dispatch(storeMarkingSchemeTitle(response?.title))
          dispatch(storeMarkingSchemeDesc(response?.description))
          dispatch(storeMarkingSchemeObjective(response?.objectiveQuestion))
          dispatch(storeMarkingSchemeSubjective(response?.subjectiveQuestion))
          dispatch(markedSchemeCardDetails(response))
        }
      })
  }
}

export const deleteMarkingScheme = (callBack = null, successCallBack = null) => {
  return (dispatch, getState) => {
    const { markedSchemeCardIdContainer } = getState().testAdmin;
    return Api.delete("/marking-scheme/deleteScheme")
      .params({ schemeId: markedSchemeCardIdContainer })
      .send((response) => {
        if (callBack) {
          callBack();
        }
        if (response != undefined) {
          if (successCallBack) {
            successCallBack();
          }
        }
      })
  }
}

export const markedSchemeCardDetails = (val) => ({
  type: MARKED_SCHEME_CARD_DETAILS,
  val
})

export const storeMarkedSchemeCardId = (val) => ({
  type: STORE_MARKED_SCHEME_CARD_ID,
  val
})

export const setSelectedSectionId = (val) => ({
  type: SET_SELECTED_SECTION_ID,
  val
})

export const addNewQuestion = (value, name, index) => ({
  type: ADD_NEW_QUESTIONS,
  value,
  name,
  index
});

export const updateQuestionType = (value, options) => ({
  type: UPDATE_QUESTION_TYPE,
  value,
  options
});

// Coding question fields (statement stays on the shared editor)
export const updateCodingQuestion = (questionContent, answerContent) => ({
  type: UPDATE_CODING_QUESTION,
  questionContent,
  answerContent
});

export const storeQuestionIndex = (value) => ({
  type: STORE_QUESTION_INDEX,
  value
})

export const storeSectionIndex = (value) => ({
  type: STORE_SECTION_INDEX,
  value
})

export const createAdditionalQuestion = (identifier, value) => ({
  type: CREATE_ADDITIONAL_QUESTION,
  identifier,
  value
})

export const storeSchemeId = (value) => ({
  type: STORE_SCHEME_ID,
  value
})

export const getMarkingSchemeMarks = (type, callBack = null) => {
  return (dispatch, getState) => {
    const { schemeId } = getState().testAdmin
    if ((type !== null && type !== undefined) && (schemeId !== null && schemeId !== undefined)) {
      return Api.get("/marking-scheme/question-mark")
        .params({ typeOfQuestion: type, schemeId: schemeId })
        .send((response) => {
          if (callBack) {
            callBack(response)
          }
          if (response != undefined) {
            dispatch(addMarkingSchemeMarks(response))
          }
        })
    } else {
      return null
    }
  }
}

export const addMarkingSchemeMarks = (data) => ({
  type: ADD_MARKING_SCHEME_MARKS,
  data
})

export const getQuestionNumbers = (callBack = null) => {
  return (dispatch, getState) => {
    const { generateQuesListViewData, deletingChapterId } = getState().testAdmin;
    return Api.get("/testv2/question-by-chapter")
      .params({
        testId: generateQuesListViewData?.id,
        chapterId: deletingChapterId
      })
      .send((response) => {
        if (callBack) {
          callBack()
        }
        if (response != undefined) {
          dispatch(totalQuesInChapter(response))
        }
      })
  }
}

export const DeleteChapterInTest = (callBack = null) => {
  return (dispatch, getState) => {
    const { generateQuesListViewData, deletingChapterId } = getState().testAdmin;
    return Api.delete("/testv2/delete-chapter-in-test")
      .params({
        testId: generateQuesListViewData?.id,
        chapterId: deletingChapterId
      })
      .send((response) => {
        if (callBack) {
          callBack()
        }
        if (response != undefined) {
          dispatch(totalQuesInChapter(response))
          if (response?.show?.type !== 'error') {
            dispatch(refreshTestQuestionLists(generateQuesListViewData?.id))
          }
        }
      })
  }
}

// Reload only the question lists after questions are removed, so the questions screen drops them without resetting the edit form.
const refreshTestQuestionLists = (testId) => {
  return (dispatch, getState) => {
    if (!testId) return;
    // Keep the list view in the shape its page loaded it in (with or without full questions).
    const { generateQuesListViewData } = getState().testAdmin;
    const firstSubject = generateQuesListViewData?.subjects?.[0];
    const firstQuestion = firstSubject?.questions?.[0] ?? firstSubject?.sections?.[0]?.questions?.[0];
    const listShape = typeof firstQuestion === 'object' && firstQuestion !== null;
    Api.get(`/testv2/test-by-id-admin/${testId}?questions=0`).send(response => {
      if (Array.isArray(response?.subjects)) {
        if (!listShape) {
          dispatch(storeGenerateQuesListView(response));
        }
        dispatch(updateListOfQuestions(injectQuestionIndex(response)));
      }
    });
    if (listShape) {
      Api.get(`/testv2/test-by-id-admin/${testId}?questions=`).send(response => {
        if (Array.isArray(response?.subjects)) {
          dispatch(storeGenerateQuesListView(injectQuestionIndex(response, 'list')));
        }
      });
    }
  }
}

export const totalQuesInChapter = (val) => ({
  type: TOTAL_QUES_IN_CHAPTER,
  val
})

export const storeDeletingChapterId = (val) => ({
  type: STORE_DELETING_CHAPTER_ID,
  val
})

export const modifyOptions = (index, operation, qIndexType, qType) => ({
  type: MODIFY_OPTIONS,
  index,
  operation,
  qIndexType,
  qType
})

export const postPublishAllReady = (callBack = null) => {
  return (dispatch, getState) => {
    return Api.post(`/test/publish-all-ready`).params().send(response => {
      callBack()
      if (response != undefined) {
      }
    });
  }
}

export const setFromImportListView = (val) => ({
  type: SET_FROM_IMPORT_LIST_VIEW,
  val
})

export const setStartTimeTest = (val) => ({
  type: SAVE_START_TIME,
  val
})